<template>
	<div class="chat" :style='pindaoStyle'>
		<transition name="fade">
			<div class="loadGif" v-if="loadGif">
				<img src="../../assets/img/load.gif" />
			</div>
		</transition>

		<div class="wrap" :style='wrapStyle' ref="wrap">
			<qun v-if="qunShow" ref="mychildQun"></qun>
			<send v-if="sendimgShow" ref="mychildsendimg"></send>
			<div class="moreInfo" @click="moreInfo()" v-if="moreShow">点击加载更多</div>
			<div class="wrapBox" v-for="(item,index) in infoData.list" :key="index">

				<div :id="'dom'+index" v-if="item.biz_type=='NOTICE'" class="myNOTICE">{{item.msg_content.content}}
				</div>
				<div v-else="">
					<div :id="'dom'+index" class="leftMsg" v-if="item.msg_from_account!=phone&&item.msg_content.show">
						<div class="tp" v-if="myInfo.ms_type!='2'">
							<img :src="item.msg_from_logo" />
						</div>
						<div class="box" @click.self="moreMenu(item,index)" :style='pindaoStyleBoxleft'>
							<div class="menus" v-if="menushow===index">
								<div class="it" v-if="item.biz_type!='COUPON'&&item.biz_type!='TLJ'"
									@click.self="sendQun(index,item)">
									分享到群
								</div>
								<div class="it" v-if="item.biz_type!='COUPON'&&item.biz_type!='TLJ'"
									@click.self="sendPindao(index,item)">
									分享到频道
								</div>
								<div class="it" @click.self="hfFC(item)" v-if="item.biz_type!='TLJ'">
									回复
								</div>
								<div class="it" @click.self="cheHui(index,item)">
									撤回
								</div>
								<div class="it" @click.self="jubao(index,item)">
									举报
								</div>
							</div>
							<div class="name" v-html='myInfo.name'></div>
							<div class="date" v-if="item.update_time">
								{{item.update_time | timestamp}} <span v-if="myInfo.ms_type!='0'"
									style="color: #999999;">(已读{{item.read_times}})</span>
							</div>
							<div style="clear: both;"></div>
							<!--文本-->
							<div class="content" v-if="item.biz_type=='TEXT'">
								<reply :item="item"></reply>
								<div class="text" style='white-space:pre-wrap'
									v-html='getUrl(item.msg_content.content)'></div>
							</div>
							<!--商品-->
							<div class="content" v-if="item.biz_type=='GOODS'">
								<reply :item="item"></reply>
								<div class="goodsmy">
									<img :src="item.msg_content.img" />
									<div class="text" style='white-space:pre-wrap'
										v-html='getUrl(item.msg_content.title)'></div>
									<h1>
										<label>原价:</label>
										<del>{{item.msg_content.price | tows}}</del>
									</h1>
									<h1>
										<label>现价:</label>
										<span>{{item.msg_content.dprice | tows}}</span>
									</h1>
								</div>
							</div>


							<!--图片-->
							<div class="content White" v-if="item.biz_type=='PIC_FILE'"
								style="background: #FFFFFF;box-shadow: 0px 0px 10px rgba(0,0,0,0.6) !important;">
								<reply :item="item"></reply>
								<div class="text mypic">
									<el-image style="width: 300px" :src="item.msg_content.url"
										:preview-src-list="[item.msg_content.url]">
									</el-image>
								</div>
							</div>

							<!--多图-->
							<div class="content White" v-if="item.biz_type=='PIC_FILES'"
								style="background: #FFFFFF;box-shadow: 0px 0px 10px rgba(0,0,0,0.6) !important;">
								<reply :item="item"></reply>
								<div class="text mypic">
									<ul v-if="item.msg_content.images instanceof Array">
										<li v-for="(src,index) in item.msg_content.images" :key="index">
											<el-image :src="src" :preview-src-list="item.msg_content.images"
												fit="cover">
											</el-image>
										</li>
									</ul>
									<div class="text" style='white-space:pre-wrap;color: #333333;'
										v-html='item.msg_content.content'></div>
								</div>
							</div>

							<!--视频-->
							<div class="content White" v-if="item.biz_type=='VIDEO_FILE'">
								<reply :item="item"></reply>
								<div class="text" style="width: 400px;">
									<!--//controls-->
									<!--<video 
											:id="'media'+index" 
											controls 
											:src="item.msg_content.url" 
											ref="video" 
											width="200px" 
											@play="playY('media'+index)">
										</video>						   -->
									<videos :srcitem="item.msg_content.url" :index="index"></videos>
								</div>







							</div>

							<!--优惠券-->
							<div class="content White" v-if="item.biz_type=='COUPON'">
								<reply :item="item"></reply>
								<div class="text" @click="dowloadApp">
									<div class="coupon" v-if="item.msg_content.coup_amt!=undefined">
										<div class="title">{{item.msg_content.coup_amt}}</div>
										<div class="cont">
											<p class="qiang">{{item.msg_content.discount_price}}</p>
											<p class="shou">{{item.msg_content.sales_price}}</p>
										</div>
										<div class="say">点击下载客汇宝APP即可领取使用</div>
									</div>

									<div class="coupon" v-else>
										<div class="title">{{item.msg_content.coupons.title}}</div>
										<div class="cont">
											<p>{{item.msg_content.coupons.desc}}</p>
										</div>
										<div class="say">点击下载客汇宝APP即可领取使用</div>
									</div>
								</div>
							</div>

							<!--淘红包-->
							<div class="content contentTLJ" v-if="item.biz_type=='TLJ'" @click="taoHongBao(item)">
								<div class="name">{{item.msg_content.tlj.title}}</div>
								<div class="tt">淘红包</div>
							</div>
							<!--音乐-->
							<div class="contentMUSIC" v-if="item.biz_type=='MUSIC'">
								<reply :item="item"></reply>
								<div class="aplayerbox">
									<aplayer :music="{title: item.msg_content.song_title,
													    artist: item.msg_content.singer_title,
													    src: item.msg_content.song_url,
													    pic: item.msg_content.song_logo
													  }">
									</aplayer>
									<a class="el-icon-download downloadmp3" target="_blank"
										:href="item.msg_content.song_url" :download="item.msg_content.song_title"></a>
								</div>

							</div>
							<!--文件-->
							<div class="cardWrap" v-if="item.biz_type=='FILE'">
								<reply :item="item"></reply>
								<a class="wenjianBox" :href="item.msg_content.url">
									<div class="imgs">
										<img src="../../assets/img/wenjian.png" class="hds" />
									</div>
									<div class="textbox">
										<div class="titles">{{item.msg_content.urlName}}</div>
									</div>
								</a>
							</div>
							<!--服务账单-->
							<div class="cardWrap" v-if="item.biz_type=='BOTPAY'" style="margin: 0px 0px;">
								<reply :item="item"></reply>
								<div class="cardBox fuwuBox" @click="alert()">
									<div class="fuwu">
										<div class="fuwu_top">
											<img :src="item.msg_content.logo" />
											<div class="rons">
												<div class="order">{{item.msg_content.title}}</div>
												<div class="money">{{item.msg_content.amount}}电池</div>
											</div>
										</div>
										<div class="zd">服务账单</div>
									</div>
								</div>
							</div>
							<!--卡片-->
							<div class="cardWrap" v-if="item.biz_type=='CARD'">
								<reply :item="item"></reply>
								<div class="cardBox" @click="check(item)">
									<div class="imgs">
										<img class="hds" src="../../assets/img/q1.fw.png"
											v-if="item.msg_content.type=='0'" />
										<img class="hds" src="../../assets/img/q3.fw.png"
											v-if="item.msg_content.type=='1'" />
										<img :src="item.msg_content.info.logo" />
									</div>
									<div class="textbox">
										<div class="titles">{{item.msg_content.info.title}}</div>
										<div class="desc" v-if="item.msg_content.info.desc==''">暂无公告</div>
										<div class="desc" v-if="item.msg_content.info.desc!=''">
											{{item.msg_content.info.desc}}</div>
									</div>
								</div>
							</div>



						</div>
					</div>

					<div :id="'dom'+index" class="leftMsg rightMsg" v-if="item.msg_from_account==phone">
						<div class="tp">
							<img :src="item.msg_from_logo" />
						</div>
						<div class="box" @click.self="moreMenu(item,index)">
							<div class="menus" v-if="menushow===index" style="left: 0;right: auto;">
								<div class="it" v-if="item.biz_type!='COUPON'&&item.biz_type!='TLJ'"
									@click.self="sendQun(index,item)">
									分享到群
								</div>
								<div class="it" v-if="item.biz_type!='COUPON'&&item.biz_type!='TLJ'"
									@click.self="sendPindao(index,item)">
									分享到频道
								</div>
								<div class="it" @click.self="hfFC(item)" v-if="item.biz_type!='TLJ'">
									回复
								</div>
								<div class="it" @click.self="cheHui(index,item)">
									撤回
								</div>
								<div class="it" @click.self="jubao(index,item)">
									举报
								</div>
							</div>

							<div class="name" v-html='item.msg_from_nick'></div>
							<div class="date" v-if="item.update_time">
								{{item.update_time | timestamp}} <span v-if="myInfo.ms_type!='0'"
									style="color: #999999;">(已读{{item.read_times}})</span>
							</div>
							<div style="clear: both;"></div>

							<!--文本-->
							<div class="content" v-if="item.biz_type=='TEXT'">
								<reply :item="item"></reply>
								<div class="text" style='white-space:pre-wrap'
									v-html='getUrl(item.msg_content.content)'></div>
							</div>

							<!--商品-->
							<div class="content" v-if="item.biz_type=='GOODS'">
								<reply :item="item"></reply>
								<div class="goodsmy">
									<img :src="item.msg_content.img" />
									<div class="text" style='white-space:pre-wrap'
										v-html='getUrl(item.msg_content.title)'></div>
									<h1>
										<label>原价:</label>
										<del>{{item.msg_content.price | tows}}</del>
									</h1>
									<h1>
										<label>现价:</label>
										<span>{{item.msg_content.dprice | tows}}</span>
									</h1>
								</div>
							</div>

							<!--图片-->
							<div class="content White" v-if="item.biz_type=='PIC_FILE'">
								<reply :item="item"></reply>
								<div class="text mypic">
									<el-image style="width: 300px" :src="item.msg_content.url"
										:preview-src-list="[item.msg_content.url]">
									</el-image>
								</div>
							</div>

							<!--多图-->
							<div class="content White" v-if="item.biz_type=='PIC_FILES'"
								style="background: #FFFFFF;box-shadow: 0px 0px 10px rgba(0,0,0,0.6) !important;">
								<reply :item="item"></reply>
								<div class="text mypic">
									<ul>
										<li v-for="(src,index) in item.msg_content.images" :key="index">
											<el-image :src="src" :preview-src-list="item.msg_content.images"
												fit="cover">
											</el-image>
										</li>
									</ul>
									<div class="text" style='white-space:pre-wrap;color: #333333;'
										v-html='item.msg_content.content'></div>
								</div>
							</div>

							<!--视频-->
							<div class="content White" v-if="item.biz_type=='VIDEO_FILE'">
								<reply :item="item"></reply>
								<div class="text" style="width: 400px;">
									<!--//controls-->
									<!--<video 
											:id="'media'+index" 
											controls 
											:src="item.msg_content.url" 
											ref="video" 
											width="200px" 
											@play="playY('media'+index)">
										</video>						 -->

									<videos :srcitem="item.msg_content.url" :index="index"></videos>
								</div>





							</div>

							<!--优惠券-->
							<div class="content White" v-if="item.biz_type=='COUPON'">
								<reply :item="item"></reply>
								<div class="text" @click="dowloadApp">
									<div class="coupon" v-if="item.msg_content.coup_amt!=undefined">
										<div class="title">{{item.msg_content.coup_amt}}</div>
										<div class="cont">
											<p class="qiang">{{item.msg_content.discount_price}}</p>
											<p class="shou">{{item.msg_content.sales_price}}</p>
										</div>
										<div class="say">点击下载客汇宝APP即可领取使用</div>
									</div>
									<div class="coupon" v-else>
										<div class="title">{{item.msg_content.coupons.title}}</div>
										<div class="cont">
											<p>{{item.msg_content.coupons.desc}}</p>
										</div>
										<div class="say">点击下载客汇宝APP即可领取使用</div>
									</div>
								</div>
							</div>

							<!--淘红包-->
							<div class="content contentTLJ" v-if="item.biz_type=='TLJ'" @click="taoHongBao(item)">
								<div class="name">{{item.msg_content.tlj.title}}</div>
								<div class="tt">淘红包</div>
							</div>
							<!--音乐-->
							<div class="contentMUSIC" v-if="item.biz_type=='MUSIC'">
								<reply :item="item"></reply>
								<div class="aplayerbox">
									<aplayer :music="{title: item.msg_content.song_title,
													    artist: item.msg_content.singer_title,
													    src: item.msg_content.song_url,
													    pic: item.msg_content.song_logo
													  }">
									</aplayer>
									<a class="el-icon-download downloadmp3" target="_blank"
										:href="item.msg_content.song_url" :download="item.msg_content.song_title"></a>
								</div>
							</div>

							<!--文件-->
							<div class="cardWrap" v-if="item.biz_type=='FILE'">
								<reply :item="item"></reply>
								<a class="wenjianBox" :href="item.msg_content.url">
									<div class="imgs">
										<img src="../../assets/img/wenjian.png" class="hds" />
									</div>
									<div class="textbox">
										<div class="titles">{{item.msg_content.urlName}}</div>
									</div>
								</a>
							</div>
							<!--服务账单-->
							<div class="cardWrap" v-if="item.biz_type=='BOTPAY'" style="margin: 0px 0px;">
								<reply :item="item"></reply>
								<div class="cardBox fuwuBox" @click="alert()">
									<div class="fuwu">
										<div class="fuwu_top">
											<img :src="item.msg_content.logo" />
											<div class="rons">
												<div class="order">{{item.msg_content.title}}</div>
												<div class="money">{{item.msg_content.amount}}电池</div>
											</div>
										</div>
										<div class="zd">服务账单</div>
									</div>
								</div>
							</div>
							<!--卡片-->
							<div class="cardWrap" v-if="item.biz_type=='CARD'">
								<reply :item="item"></reply>
								<div class="cardBox" @click="check(item)">
									<div class="imgs">
										<img class="hds" src="../../assets/img/q1.fw.png"
											v-if="item.msg_content.type=='0'" />
										<img class="hds" src="../../assets/img/q3.fw.png"
											v-if="item.msg_content.type=='1'" />
										<img :src="item.msg_content.info.logo" />
									</div>
									<div class="textbox">
										<div class="titles">{{item.msg_content.info.title}}</div>
										<div class="desc" v-if="item.msg_content.info.desc==''">暂无公告</div>
										<div class="desc" v-if="item.msg_content.info.desc!=''">
											{{item.msg_content.info.desc}}</div>
									</div>
								</div>
							</div>


							<div style="clear: both;"></div>
						</div>
					</div>

				</div>


			</div>
		</div>


		<!-- 回复卡片 -->
		<div @drop="enentDrop($event)" @dragleave="dragleave($event)" @dragover="dragover($event)">
			<div class="myMsg" v-if="myPindao">
				<div class="huiFuXX" v-if="hfData">
					<div class="replyBox">
						<div class="replyItem" v-if="hfData.biz_type=='TEXT'">
							<div class="replyName">{{hfData.msg_from_nick}}</div>
							<div class="replyCotent">{{hfData.msg_content.content}}</div>
						</div>
						<div class="replyItem" v-if="hfData.biz_type=='PIC_FILES'">
							<img class="replyImg" :src="hfData.msg_content.images[0]" />
							<div class="rons">
								<div class="replyName">{{hfData.msg_from_nick}}</div>
								<div class="replyCotent">图片</div>
							</div>
						</div>
						<div class="replyItem" v-if="hfData.biz_type=='PIC_FILE'">
							<img class="replyImg" :src="hfData.msg_content.url" />
							<div class="rons">
								<div class="replyName">{{hfData.msg_from_nick}}</div>
								<div class="replyCotent row1">图片</div>
							</div>
						</div>
						<div class="replyItem" v-if="hfData.biz_type=='VIDEO_FILE'">
							<img class="replyImg" :src="hfData.msg_content.url+'?vframe/jpg/offset/1/w/60/h/60'" />
							<div class="rons">
								<div class="replyName">{{hfData.msg_from_nick}}</div>
								<div class="replyCotent row1">视频</div>
							</div>
						</div>
						<div class="replyItem" v-if="hfData.biz_type=='COUPON'">
							<div class="replyName">{{hfData.msg_from_nick}}</div>
							<div class="replyCotent">优惠券</div>
						</div>
						<div class="replyItem" v-if="hfData.biz_type=='TLJ'">
							<div class="replyName">{{hfData.msg_from_nick}}</div>
							<div class="replyCotent">淘红包</div>
						</div>
						<div class="replyItem" v-if="hfData.biz_type=='GOODS'">
							<img class="replyImg" :src="hfData.msg_content.img" />
							<div class="rons">
								<div class="replyName">{{hfData.msg_from_nick}}</div>
								<div class="replyCotent row1">{{hfData.msg_content.title | length18}}</div>
							</div>
						</div>
						<div class="replyItem" v-if="hfData.biz_type=='MUSIC'">
							<img class="replyImg" :src="hfData.msg_content.song_logo" />
							<div class="rons">
								<div class="replyName">
									{{hfData.msg_content.song_title}}+{{hfData.msg_content.singer_title}}</div>
								<div class="replyCotent row1">音乐</div>
							</div>
						</div>
						<div class="replyItem" v-if="hfData.biz_type=='CARD'">
							<img class="replyImg" :src="hfData.msg_content.info.logo" />
							<div class="rons">
								<div class="replyName">{{hfData.msg_content.info.title}}</div>
								<div class="replyCotent row1">名片</div>
							</div>
						</div>


					</div>
					<div class="close">
						<i class="el-icon-close" @click="closehf"></i>
					</div>
				</div>

				<div class="top">
					<!-- <transition name="el-zoom-in-bottom">
        <div v-show="bindAIShow" class="transition-box aibox">
        				<div class="aititle">
        					<div class="nameai">
        						<b @click="aiListShow=true" class="aib" :class="{'aibActive':aiListShow}">机器人列表</b>
        						<b @click="aiListShow=false" class="aib" :class="{'aibActive':!aiListShow}">已绑定机器人</b>
        					</div>
        					<el-button @click.native="bindAIShow=!bindAIShow">关闭</el-button>
        				</div>
								<div class="aiRon" v-if="aiListShow">
								 <div class="aiItem aiItemb" v-for="(item,index) in bindNoData" >
								 		<img :src="item.app_logo"  />
								 		<h1>{{item.app_title}}</h1>
								 		 <el-button round @click="bangding(item)">绑定</el-button>
								 </div>   
								</div>
								<div class="aiRon" v-if="!aiListShow">
								 <div class="aiItem aiItemb" v-for="(item,index) in bindYesData" >
								 		<img :src="item.app_logo"  />
								 		<h1>{{item.app_title}}</h1>
								 		 <el-button round @click="jiebang(item)" v-if="item.app_status=='0'">解绑</el-button>
								 		 <el-button type="danger" round v-if="item.app_status=='1'">异常</el-button>
								 		 
								 </div>   
								</div>
        </div>
      </transition>			 -->
					<!-- <transition name="el-zoom-in-bottom">
        <div v-show="aiShow" class="transition-box aibox">
        				<div class="aititle">
        					<div class="name">
        						AI智能机器人
        					</div>
        					<el-button @click.native="bindAIShow=!bindAIShow;aiShow=false">绑定机器人</el-button>
        				</div>
								<div class="aiRon">
								 <div class="aiItem aiItema" v-for="(item,index) in aihuanxingci" @click="aigo(item.word)">
								 		<h1>{{item.word}}</h1>
								 		<p>{{item.title}}</p>
								 </div>   
								</div>
        </div>
      </transition>			 -->
					<ul>
						<li>
							<el-popover placement="top" width="400" trigger="click">
								<div class="emoji">
									<ul>
										<li v-for="(item,index) in emojiArr" :key="index" @click.stop="emojiAdd(item)">
											{{item}}</li>
									</ul>
								</div>
								<span slot="reference" class="icon iconfont">&#xe799;</span>
							</el-popover>
						</li>
						<li>
							<span @click.stop="goSendImg" class="icon iconfont">&#xe73f;</span>
						</li>
						<li style="width: 100px;position: relative;" v-if="percent !== 0 && percent !== 100">
							<span class="el-icon-folder-opened" style="float: left;"></span>
							<div style="position: absolute;width: 100%;height: 100%;padding-top: 10px;left: 35px;">
								<el-progress :text-inside="true" :stroke-width="20" :percentage="percent"></el-progress>
							</div>
						</li>
						<li v-else>

							<el-upload action="http://up-z1.qiniup.com" :data="qn" :show-file-list="false"
								:on-success="handleSuccess" :before-upload="beforeUpload" :on-progress="handlePro"
								:on-error="handleError">
								<span class="el-icon-folder-opened"></span>
							</el-upload>
						</li>
						<li>
							<b class="backgrondfff" @click.stop="change"
								:class="{'activeBackground': activeChecked }">隐私模式</b>
						</li>
						<!-- <li class="ai" @click="aiShow=!aiShow;bindAIShow=false" v-if="myInfo.ms_type!='0'">
						<svg t="1609833811930"  viewBox="0 0 1179 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1511" width="27" height="27"><path d="M597.215632 994.574713h403.714943s43.549425-8.945287 43.549425-114.64092 94.16092-577.677241-459.976092-577.677241-457.151264 541.425287-457.151264 541.425287-25.423448 160.77977 54.848735 157.013333 415.014253-6.12046 415.014253-6.120459z" fill="#FFFFFF" p-id="1512"></path><path d="M1071.786667 712.798161h72.503908v136.297931h-72.503908zM36.016552 712.798161h72.503908v136.297931H36.016552z" fill="#EA5D5C" p-id="1513"></path><path d="M305.68366 559.40926l556.254412-1.165018 0.398364 190.20464-556.254412 1.165018-0.398364-190.20464Z" fill="#4C66AF" p-id="1514"></path><path d="M1129.931034 680.312644h-59.556781c-3.295632-152.069885-67.56046-258.942529-172.079081-324.384368l115.347127-238.462529a47.08046 47.08046 0 1 0-42.372414-20.48l-114.640919 236.57931a625.934713 625.934713 0 0 0-269.30023-53.200919 625.228506 625.228506 0 0 0-270.006437 54.848736l-115.817931-235.402299a47.08046 47.08046 0 1 0-42.372414 20.715402l117.701149 238.462529c-103.812414 65.441839-167.135632 173.02069-169.960459 324.61977H47.786667a47.08046 47.08046 0 0 0-47.08046 47.08046v117.701149a47.08046 47.08046 0 0 0 47.08046 47.08046h58.615172v57.908965a70.62069 70.62069 0 0 0 70.62069 70.62069l823.908046-1.647816a70.62069 70.62069 0 0 0 70.620689-70.62069v-57.908965h59.085977a47.08046 47.08046 0 0 0 47.08046-47.08046v-117.701149A47.08046 47.08046 0 0 0 1129.931034 680.312644zM94.16092 847.212874H47.08046v-117.70115h47.08046v117.70115z m929.83908 103.106206a23.54023 23.54023 0 0 1-23.54023 23.54023l-823.908046 1.647816a23.54023 23.54023 0 0 1-23.54023-23.540229v-258.942529c0-329.563218 303.668966-365.57977 434.788046-365.815173s435.494253 34.604138 436.20046 363.931954z m105.46023-105.224827h-47.08046v-117.70115h47.08046v117.70115z" fill="#3F4651" p-id="1515"></path><path d="M464.684138 135.827126l22.363218-19.53839 40.018391 62.381609a30.131494 30.131494 0 0 0 25.423448 13.888735h2.824828a30.131494 30.131494 0 0 0 25.188046-19.067586l20.715402-79.095172 21.186207 74.387126v2.118621a30.366897 30.366897 0 0 0 52.494713 6.826667l30.366896-57.202759 13.182529 12.947126a30.131494 30.131494 0 0 0 21.186207 8.709886h57.673563a23.54023 23.54023 0 0 0 23.54023-23.54023 23.54023 23.54023 0 0 0-23.54023-23.54023h-50.140689l-23.54023-23.54023a30.366897 30.366897 0 0 0-45.668046 3.766437l-21.42161 40.01839L629.465747 19.302989a30.131494 30.131494 0 0 0-28.012873-19.067587 30.131494 30.131494 0 0 0-28.012874 19.067587l-26.60046 101.693793-29.660689-47.08046a30.366897 30.366897 0 0 0-20.48-13.653333 30.837701 30.837701 0 0 0-23.54023 6.826666l-32.250115 28.248276h-60.027586a23.54023 23.54023 0 0 0-23.54023 23.54023 23.54023 23.54023 0 0 0 23.54023 23.54023h66.148046a31.308506 31.308506 0 0 0 17.655172-6.591265zM776.121379 532.950805H404.421149A121.232184 121.232184 0 0 0 282.482759 639.352644a117.701149 117.701149 0 0 0 117.701149 129.000459h371.70023a121.232184 121.232184 0 0 0 121.938391-106.401839 117.701149 117.701149 0 0 0-117.70115-129.000459z m0 188.321839H402.302529a72.503908 72.503908 0 0 1-72.268506-56.496552 70.62069 70.62069 0 0 1 68.972874-84.744828h373.81885a72.503908 72.503908 0 0 1 72.268506 56.496552 70.62069 70.62069 0 0 1-68.502069 84.744828z" fill="#3F4651" p-id="1516"></path></svg>
				</li> -->

					</ul>
				</div>

				<!-- 输入框 -->
				<!-- <div class="center"  >
			<textarea  v-model="myValue" :placeholder="textChange"></textarea>
		</div> -->

				<div style="width: 100%" @dragenter="dragenter($event)">
					<div v-if="fileData!=''" style="display: inline-block; height: 40px; width:100%;overflow-y:auto;">
						<span v-for="(item, index) in fileData" :key="index" style=" margin-left: 1%;">
							<span v-if="item.type!='image/jpeg' && item.type!='image/png' && item.type!='image/gif'"
								slot="reference"
								style="float: left;
					margin-top: 8px;width:30%;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;position: relative;background: #409EFF;margin-left: 2%;">
								{{item.name}}
								<i style="color: red;position: absolute; top: 20%; right: 0;" class="el-icon-close"
									@click='guanbiwj(index)'></i>
							</span>

							<span v-if="item.type=='image/jpeg' || item.type=='image/png' || item.type=='image/gif'"
								style="display: inline-block !important; width:8%;margin-top: 5px; height: 35px; background: coral;margin-left: 10px; position: relative;">
								<!-- <img style="width: 100%; height: 100%;" :src="item.img" alt=""> -->
								<el-image style="width: 100%;height: 100%;" :src="item.img"
									:preview-src-list="[item.img]">
								</el-image>
								<i style="position: absolute; top: 0;right: 0;color: red;" class="el-icon-close"
									@click='guanbiwj(index)'></i>
							</span>
						</span>


					</div>

					<div class="center">
						<textarea v-model="myValue" :placeholder="textChange"></textarea>

					</div>

					<!-- <div class="drag-box">{{drapText}}</div> -->



				</div>
				<!-- <div id="drop-area" :class="dropActive ? 'drop-active' : ''" >
			
		</div> -->
				<div class="bottom">
					<div class="btn" @click.stop="sendValue($event)" @keyup.enter="enterSearch($event)">发送</div>
				</div>
			</div>
		</div>



		<div style="display: none !important;">
			<el-dialog title="点击复制淘口令打开淘宝APP" :visible.sync="dialogVisible" width="40%" :append-to-body="true"
				:before-close="handleClose">
				<div class="tkls">
					<div class="yhq">
						<div class="box" v-clipboard:copy="copyUrl" v-clipboard:success="onCopy"
							v-clipboard:error="onError">
							<div class="name">{{info.title}}</div>
							<div class="tkl">{{info.tkl}}</div>
						</div>
						<div class="tt">请点击复制打开淘宝APP使用淘红包</div>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
				</span>
			</el-dialog>
		</div>

		<!--举报-->
		<el-dialog title="举报" :visible.sync="dialogJbao" :modal="false" width="300px">
			<div class="jubaoCss">
				<el-button plain @click.native="jubaoFC('垃圾信息')">垃圾信息</el-button>
				<el-button plain @click.native="jubaoFC('暴力')">暴力</el-button>
				<el-button plain @click.native="jubaoFC('儿童虐待')">儿童虐待</el-button>
				<el-button plain @click.native="jubaoFC('色情')">色情</el-button>
				<el-button plain @click.native="jubaoFC('其他')">其他</el-button>
			</div>
			<el-button type="primary" style="display: block;width: 100%;height: 40px;" @click="dialogJbao = false">取消
			</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import Vue from 'vue';
	var qiniu = require('qiniu-js')
	import { Base64 } from '@/xiaomi/Base64.js';
	import { getMimcInfo } from '@/xiaomi/mimc.js';
	import qun from '@/components/im/qun'
	import send from '@/components/im/sendImg'
	import reply from '@/components/im/reply'
	import qs from "qs"
	import Aplayer from 'vue-aplayer'

	import videos from '@/components/im/videos'

	//复制到粘贴板插件
	import VueClipboard from 'vue-clipboard2'
	VueClipboard.config.autoSetContainer = true
	Vue.use(VueClipboard)

	var that = null;
	var bell = true;
	var indexMsg = 0;
	var htA = null
	var htB = null
	export default {

		components: {
			qun,
			send,
			reply,
			Aplayer,
			videos
		},
		data() {
			return {

				fileData: [],
				file: '',
				keys: '',
				jishu: 0,

				// dakaishuru:false,
				// dropActive:false,//拖拽
				code: '',
				suffix: '',
				aiListShow: true,
				bindYesData: [],
				bindNoData: [],
				bindAIShow: false,
				bindAIInfo: [],
				aihuanxingci: [],
				aiShow: false,
				copyUrl: '',
				info: '',
				menushow: 'ninn',
				sendimgShow: false,
				sendQunData: '',
				qunShow: false,
				phone: this.getCookie("phoneIm"),
				myPindao: false,
				infoData: [],
				showImg: false,
				imgShow: "",
				vcIsPlay: false,//video是否播放
				myValue: '',
				finished: false,
				pageNo: 0,
				disableds: false,
				userLogo: '',
				userName: '',
				myInfo: {},
				moreShow: false,
				loadGif: true,
				imageUrl: '',
				emojiArr: ['😉', '😫', '😥', '😓', '😏', '😪', '😱', '😔', '😖', '😌', '😡', '😣', '😨', '😭', '😢', '😄', '😊', '😁', '😆', '😅', '😃', '😳', '😷', '😚'],
				hfData: '',
				dialogVisible: false,
				thbData: '',
				jubaoData: '',
				dialogJbao: false,
				listData: '',
				percent: 0,
				qn: {
					token: "生成凭证中生成的token",
					key: ""
				},
				percentWenjian: '',
				percentType: {},
				activeChecked: false,
				textChange: ''
			}
		},


		computed: {
			wrapStyle() {
				return {
					bottom: "50px"
				}
			},
			pindaoStyle() {
				if (this.myPindao) {
					return {
						// 'padding-bottom': '160px'
						'padding-bottom': '220px'
					}
				} else {
					return {
						bottom: "0px",
					}
				}

			},
			pindaoStyleBoxleft() {
				if (this.myInfo.ms_type == '2') {
					return {
						'padding-left': '0'
					}
				} else {
					return {

					}
				}

			},
			gn() {
				return this.$store.state.gn
			},
			sp() {
				return this.$store.state.gn
			},
			user() {
				return this.$store.state.user
			}
		},
		moutend() {

		},
		methods: {
			qingkong() {
				this.fileData = []
			},
			zhantie(filef) {
				var reader = new FileReader()
				reader.onload = (event) => {
					filef.img = event.target.result
					this.fileData.push(filef)
				}
				reader.readAsDataURL(filef);


			},
			//粘贴复制
			getClipboardFiles(event) {
				var items = event.clipboardData && event.clipboardData.items;
				var filef = null
				if (items && items.length) {
					// 检索剪切板items
					for (var i = 0; i < items.length; i++) {
						if (items[i].type.indexOf('image') !== -1) {
							filef = items[i].getAsFile()
							this.zhantie(filef)
						}
					}
				}
				if (!filef) {
					//  this.$message.error('粘贴内容不是图片')
					return;
				}

				//  this.handleFilesAdd(file)
			},
			//删除文件
			guanbiwj(index) {
				this.fileData.splice(index, 1)
			},
			enentDrop: function (e) {
				e.stopPropagation();
				e.preventDefault();
				this.updataFun(e.dataTransfer.files)
			},
			dragleave(e) {
				e.stopPropagation();
				e.preventDefault();
			},
			dragenter(e) {
				e.stopPropagation();
				e.preventDefault();

			},
			dragover(e) {
				e.stopPropagation();
				e.preventDefault();
			},
			updataFun(data) {


				let that = this;
				for (let i = 0; i < data.length; i++) {
					//判断是不是图片
					if (data[i].type.indexOf('image') !== -1) {
						//转化为base64图片显示
						var reader = new FileReader();
						reader.onloadend = function () {

							var img = reader.result;
							data[i].img = img
							that.fileData.push(data[i])
						};
						if (data[i]) {
							reader.readAsDataURL(data[i]);
						}
					} else {
						that.fileData.push(data[i])
					}


					// if (data[i].type.indexOf('image') !== -1) {
					//      filef = data[i].getAsFile()
					// 	 console.log('te',filef)
					//     this.zhantie(filef)
					//    }else{
					// 	this.fileData.push(data[i])
					//    }
					// this.myValue = this.myValue + data[i].name
				}

				// this.drapText = '上传成功';
				// setTimeout(() => {
				//   that.drapText = '将文件拖拽到此处进行上传';
				// }, 500);
			},

			closesenImg() {
				this.sendimgShow = false
			},
			taoHongBao(data) {
				this.thbData = data
				this.getDatatkl()
			},
			handleClose(done) {
				done();
			},
			alert() {
				this.$message.error("请下载APP使用");
			},
			onCopy(e) {
				this.$message("复制成功");
			},
			onError(e) {
				this.$message.error("复制失败");
			},
			getDatatkl() {
				let params = qs.stringify({
					activity_id: this.thbData.msg_content.tlj.no
				})
				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/tlj/v1/queryTLJ', params)
					.then(userData => {

						if (userData.data.resultCode == '0000') {
							this.info = userData.data.resultInfo
							this.copyUrl = this.info.tkl
							this.dialogVisible = true
						} else {
							this.$message.error(userData.data.resultMsg)
						}
					}).catch(error => {
						console.log(error)
					})
			},
			goSendImg() {
				this.sendimgShow = true
				if (this.myInfo.ms_type == '0') {
					setTimeout(() => {
						this.$refs.mychildsendimg.getDataImg(this.myInfo.user, '0', this.hfData, this.activeChecked);
					}, 50)
				} else if (this.myInfo.ms_type == '1') {
					setTimeout(() => {
						this.$refs.mychildsendimg.getDataImg(this.myInfo.topId, '1', this.hfData, this.activeChecked);
					}, 50)
				} else if (this.myInfo.ms_type == '2') {
					setTimeout(() => {
						this.$refs.mychildsendimg.getDataImg(this.myInfo.topId, '2', this.hfData, this.activeChecked);
					}, 50)
				}
			},
			sendImgDatas(data) {
				data.content = this.decodeUnicode(data.content)
				if (data.reply != '') {
					data.reply.msg_content.content = this.decodeUnicode(data.reply.msg_content.content)
				}

				var timestampUser = String(new Date().valueOf())
				var say = {
					biz_type: 'PIC_FILES',
					update_time: timestampUser,
					msg_content: data,
					msg_from_logo: JSON.parse(this.getCookie("userInfo")).logo,
					msg_from_nick: JSON.parse(this.getCookie("userInfo")).title,
					msg_from_account: JSON.parse(this.getCookie("userInfo")).account
				}
				this.myValue = ''
				this.hfData = ''
				this.infoData.list.push(say)
				this.$nextTick(() => {
					this.$refs.wrap.scrollTop = this.$refs.wrap.scrollHeight
				})
			},
			goGetInfo(myInfo) {
				this.menushow = false
				this.loadGif = true
				setTimeout(() => {
					this.myInfo = myInfo
					this.pageNo = 0
					this.infoData = []
					this.getInfo()
				}, 100)
			},
			chooseMaster() {
				let params = qs.stringify({
					group_no: this.myInfo.msg_to,
				})

				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/v1/queryGroupsMembers', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							if (this.myInfo.ms_type != '2') {
								this.myPindao = true
							} else {
								if (this.phone == userData.data.resultInfo.owner[0].account) {
									this.myPindao = true
								} else {
									this.myPindao = false
								}
							}

						} else if (userData.data.resultCode == "1313") {
							this.$parent.loginto();
						} else {

							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})
			},

			getInfo(data) {
				console.log(this.myInfo.ms_type)
				if (data != undefined) {
					this.myInfo.ms_type = '0'
					this.myInfo.msg_to = data
				}
				// this.aiHXC()
				// this.bindAI()
				this.chooseMaster()
				this.pageNo += 1
				let params = qs.stringify({
					pageNo: this.pageNo,
					pageSize: "20"
				})
				var urlP = ''
				if (this.myInfo.ms_type == '0') {
					urlP = '/goods/mimc/v1/queryMsgList/p2p/' + this.myInfo.msg_to
				} else if (this.myInfo.ms_type == '1') {
					urlP = '/goods/mimc/v1/queryMsgList/p2t/' + this.myInfo.msg_to
				} else {
					urlP = '/goods/mimc/channel/v1/queryMsgList/' + this.myInfo.msg_to
				}
				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post(urlP, params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							userData.data.resultInfo.list.filter((item, index) => {
								userData.data.resultInfo.list[index].update_time = item.update_time
								if (this.isJson(item.msg_content)) {
									item.msg_content = JSON.parse(item.msg_content)
									userData.data.resultInfo.list[index].msg_content = item.msg_content

									if (item.biz_type == 'TEXT') {
										if (userData.data.resultInfo.list[index].msg_content.content == undefined) {
											userData.data.resultInfo.list[index].msg_content.content = "******"
										} else {
											userData.data.resultInfo.list[index].msg_content.content = this.decodeUnicode(item.msg_content.content)
										}

									}
									if (item.biz_type == 'PIC_FILES') {
										item.msg_content.content = this.decodeUnicode(item.msg_content.content)
										userData.data.resultInfo.list[index].msg_content = item.msg_content
										if (item.msg_content.imags != undefined) {
											item.msg_content.images = item.msg_content.imags
											userData.data.resultInfo.list[index].msg_content.images = item.msg_content.images
										}
									}
									if (item.biz_type == 'CARD') {

									}



									if (item.biz_type == 'COUPON') {
										if (item.msg_content.coup_amt == undefined && item.msg_content.coupons.title == undefined) {

											if (this.isJson(item.msg_content.coupons)) {
												item.msg_content.coupons = JSON.parse(item.msg_content.coupons)
												userData.data.resultInfo.list[index].msg_content.coupons = [item.msg_content.coupons]
											} else {
												userData.data.resultInfo.list[index].msg_content.coupons = [item.msg_content.coupons]
											}
										}
									}


								} else {
									if (item.biz_type == 'TEXT') {
										userData.data.resultInfo.list[index].msg_content = { content: this.decodeUnicode(item.msg_content) }
									}
									if (item.biz_type == "NOTICE") {
										userData.data.resultInfo.list[index].msg_content = { content: item.msg_content }
									}
									if (item.biz_type == "PIC_FILE") {
										userData.data.resultInfo.list[index].msg_content = { url: item.msg_content }
									}
									if (item.biz_type == "VIDEO_FILE") {
										userData.data.resultInfo.list[index].msg_content = { url: item.msg_content }
									}

								}

								if (JSON.stringify(item.msg_content.reply) == '{}') {
									item.msg_content.reply = ''
								}

								if (item.msg_content.reply == undefined) {
									item.msg_content.reply = ''
								}

								if (item.msg_content.reply != '') {

									var reply = ''
									if (item.msg_content.reply.biz_type != undefined) {
										reply = item.msg_content.reply
									} else {
										reply = JSON.parse(item.msg_content.reply)
										reply.msg_content = JSON.parse(reply.msg_content)
									}

									if (reply.msg_content.content != undefined) {
										reply.msg_content.content = this.decodeUnicode(reply.msg_content.content)
									}
									userData.data.resultInfo.list[index].msg_content.reply = reply
								}

								if (item.biz_type == 'CARD') {
									if (item.msg_content.info.account == undefined) {
										userData.data.resultInfo.list[index].msg_content.info = JSON.parse(item.msg_content.info)
									}

								}
								if (item.biz_type == "FILE") {
									userData.data.resultInfo.list[index].msg_content.urlName = this.parseURL(item.msg_content.url)
								}

								userData.data.resultInfo.list[index].msg_content.show = true
								if (item.msg_content.show_type != undefined && item.msg_content.show_type != 'all') {
									userData.data.resultInfo.list[index].msg_content.show = false
									item.msg_content.show_list = item.msg_content.show_list.substr(1)
									item.msg_content.show_list = item.msg_content.show_list.substr(0, item.msg_content.show_list.length - 1);
									userData.data.resultInfo.list[index].msg_content.show_list = item.msg_content.show_list.split(',')
									userData.data.resultInfo.list[index].msg_content.show_list.filter((item) => {
										if (item == this.myconNum) {
											userData.data.resultInfo.list[index].msg_content.show = true
										}
									})
								}
							})

							userData.data.resultInfo.list = userData.data.resultInfo.list.reverse()
							if (this.infoData.length == '0') {
								this.infoData = userData.data.resultInfo
								this.$nextTick(() => {
									setTimeout(() => {
										this.$refs.wrap.scrollTop = this.$refs.wrap.scrollHeight
									}, 30)

								})
							} else {
								this.infoData.list = userData.data.resultInfo.list.concat(this.infoData.list)
							}
							if (this.infoData.list.length >= this.infoData.total) {
								this.moreShow = false
							} else {
								this.moreShow = true
							}


						} else if (userData.data.resultCode == "1313") {
							this.$parent.loginto();
						} else {

							this.$message.error(userData.data.resultMsg);
						}
						this.loadGif = false

						setTimeout(() => {
							this.UpdateGetList()
						}, 3000)

					}).catch(error => {
						console.log(error)
					})
			},
			UpdateGetList() {
				let params = qs.stringify({
					pageNo: 1,
					pageSize: 20,
					ignore: '1'
				})
				var urlP = ''
				if (this.myInfo.ms_type == '0') {
					urlP = '/goods/mimc/v1/queryMsgList/p2p/' + this.myInfo.msg_to
				} else if (this.myInfo.ms_type == '1') {
					urlP = '/goods/mimc/v1/queryMsgList/p2t/' + this.myInfo.msg_to
				} else {

					urlP = '/goods/mimc/channel/v1/queryMsgList/' + this.myInfo.msg_to
				}
				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post(urlP, params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							userData.data.resultInfo.list.filter((item, index) => {
								userData.data.resultInfo.list[index].update_time = item.update_time
								if (this.isJson(item.msg_content)) {
									item.msg_content = JSON.parse(item.msg_content)
									userData.data.resultInfo.list[index].msg_content = item.msg_content

									if (item.biz_type == 'TEXT') {
										if (userData.data.resultInfo.list[index].msg_content.content == undefined) {
											userData.data.resultInfo.list[index].msg_content.content = "******"
										} else {
											userData.data.resultInfo.list[index].msg_content.content = this.decodeUnicode(item.msg_content.content)
										}

									}
									if (item.biz_type == 'PIC_FILES') {
										item.msg_content.content = this.decodeUnicode(item.msg_content.content)
										userData.data.resultInfo.list[index].msg_content = item.msg_content
										if (item.msg_content.imags != undefined) {
											item.msg_content.images = item.msg_content.imags
											userData.data.resultInfo.list[index].msg_content.images = item.msg_content.images
										}
									}
									if (item.biz_type == 'CARD') {

									}



									if (item.biz_type == 'COUPON') {
										if (item.msg_content.coup_amt == undefined && item.msg_content.coupons.title == undefined) {

											if (this.isJson(item.msg_content.coupons)) {
												item.msg_content.coupons = JSON.parse(item.msg_content.coupons)
												userData.data.resultInfo.list[index].msg_content.coupons = [item.msg_content.coupons]
											} else {
												userData.data.resultInfo.list[index].msg_content.coupons = [item.msg_content.coupons]
											}
										}
									}


								} else {
									if (item.biz_type == 'TEXT') {
										userData.data.resultInfo.list[index].msg_content = { content: this.decodeUnicode(item.msg_content) }
									}
									if (item.biz_type == "NOTICE") {
										userData.data.resultInfo.list[index].msg_content = { content: item.msg_content }
									}
									if (item.biz_type == "PIC_FILE") {
										userData.data.resultInfo.list[index].msg_content = { url: item.msg_content }
									}
									if (item.biz_type == "VIDEO_FILE") {
										userData.data.resultInfo.list[index].msg_content = { url: item.msg_content }
									}

								}

								if (JSON.stringify(item.msg_content.reply) == '{}') {
									item.msg_content.reply = ''
								}

								if (item.msg_content.reply == undefined) {
									item.msg_content.reply = ''
								}

								if (item.msg_content.reply != '') {

									var reply = ''
									if (item.msg_content.reply.biz_type != undefined) {
										reply = item.msg_content.reply
									} else {
										reply = JSON.parse(item.msg_content.reply)
										reply.msg_content = JSON.parse(reply.msg_content)
									}

									if (reply.msg_content.content != undefined) {
										reply.msg_content.content = this.decodeUnicode(reply.msg_content.content)
									}
									userData.data.resultInfo.list[index].msg_content.reply = reply
								}

								if (item.biz_type == 'CARD') {
									if (item.msg_content.info.account == undefined) {
										userData.data.resultInfo.list[index].msg_content.info = JSON.parse(item.msg_content.info)
									}

								}
								if (item.biz_type == "FILE") {
									userData.data.resultInfo.list[index].msg_content.urlName = this.parseURL(item.msg_content.url)
								}

								userData.data.resultInfo.list[index].msg_content.show = true
								if (item.msg_content.show_type != undefined && item.msg_content.show_type != 'all') {
									userData.data.resultInfo.list[index].msg_content.show = false
									item.msg_content.show_list = item.msg_content.show_list.substr(1)
									item.msg_content.show_list = item.msg_content.show_list.substr(0, item.msg_content.show_list.length - 1);
									userData.data.resultInfo.list[index].msg_content.show_list = item.msg_content.show_list.split(',')
									userData.data.resultInfo.list[index].msg_content.show_list.filter((item) => {
										if (item == this.myconNum) {
											userData.data.resultInfo.list[index].msg_content.show = true
										}
									})
								}
							})

							userData.data.resultInfo.list = userData.data.resultInfo.list.reverse()

							var dataup = []
							dataup = userData.data.resultInfo.list
							dataup.filter((item, index) => {
								if (this.infoData.list.length == '0') {
									this.infoData.list.push(item)
								} else if (item.id > this.infoData.list[this.infoData.list.length - 1].id) {
									this.infoData.list.push(item)
								}
							})

							if (this.myInfo.ms_type == '0' || this.myInfo.ms_type == '1') {
								return false
							}
							setTimeout(() => {
								this.UpdateGetList()
							}, 3000)









						}
					}).catch(error => {
						console.log(error)
					})
			},
			parseURL(url) {
				return url.substring(url.lastIndexOf('/') + 1);
			},
			isJson(str) {
				if (typeof str == 'string') {
					try {
						var obj = JSON.parse(str);
						if (typeof obj == 'object' && obj) {
							return true;
						} else {
							return false;
						}
					} catch (e) {
						return false;
					}
				}
			},
			dowloadApp() {
				this.$message("请下载客汇宝App领取");
			},
			moreInfo() {
				this.getInfo()
			},
			getUrl(text) {
				var regexp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
				return text = text.replace(regexp, function ($url) {
					return "<a style='cursor: pointer;color:#0088cc' href='" + $url + "' target='_blank'>" + $url + "</a>";

				})
			},
			randomString(len) {
				len = len || 32;
				var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
				var maxPos = $chars.length;
				var pwd = '';
				for (var i = 0; i < len; i++) {
					pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
				}
				return pwd;
			},
			encodeUnicode(str) {
				//加码
				var res = [];
				for (var i = 0; i < str.length; i++) {
					res[i] = ("000" + str.charCodeAt(i).toString(16)).slice(-4);
				}
				return "\\u" + res.join("\\u");
			},
			decodeUnicode(str) {
				str = str.replace(/\\/g, "%"); return unescape(str);
			},
			myP2TMsg(P2TMsg) {
				//群
				if (this.myInfo.topId == P2TMsg.getTopicId()) {
					var msgData = JSON.parse(P2TMsg.getPayload())
					var msg = Base64.decode(msgData.payload)
					msg = JSON.parse(msg);
					var currenture = new Date().getTime();
					var t = (currenture - msgData.timestamp) / 24 / 60 / 60 / 1000
					if (t >= '1') {
						//过滤除了当天的消息
						return false
					}
					if (P2TMsg.getBizType() == 'TEXT') {
						msg.content = this.decodeUnicode(msg.content)
					}
					if (P2TMsg.getBizType() == 'PIC_FILE') {
						msg.url = this.decodeUnicode(msg.url)
					}
					if (P2TMsg.getBizType() == 'PIC_FILES') {
						msg.content = this.decodeUnicode(msg.content)
					}

					if (JSON.stringify(msg.reply) == '{}') {
						msg.reply = ''
					}
					if (msg.reply == undefined) {
						msg.reply = ''
					}
					if (msg.reply != '') {
						msg.reply = JSON.parse(msg.reply)
						msg.reply.msg_content = JSON.parse(msg.reply.msg_content)
						if (msg.reply.msg_content.content != undefined) {
							msg.reply.msg_content.content = this.decodeUnicode(msg.reply.msg_content.content)
						}
					}

					msg.show = true
					if (msg.show_type != undefined && msg.show_type != 'all') {
						msg.show = false
						msg.show_list = msg.show_list.substr(1)
						msg.show_list = msg.show_list.substr(0, msg.show_list.length - 1);
						msg.show_list = msg.show_list.split(',')
						msg.show_list.filter((item) => {
							if (item == this.myconNum) {
								msg.show = true
							}
						})
					}



					var say = {
						biz_type: P2TMsg.getBizType(),
						msg_from_nick: msgData.nickname,
						update_time: msgData.timestamp,
						msg_from_logo: msgData.logo,
						msg_id: msgData.msgId,
						msg_content: msg,
						msg_from_account: P2TMsg.getFromAccount()
					}
					if (say.msg_content.func == 'reply' && JSON.parse(this.getCookie("userInfo")).conNum == JSON.parse(say.msg_content.func_list)[0]) {
						this.hfData = say
					}
					this.infoData.list.push(say)

					this.$nextTick(() => {
						this.$refs.wrap.scrollTop = this.$refs.wrap.scrollHeight

					})
				}
			},
			myP2PMsg(P2PMsg) {
				//单聊
				if (this.myInfo.user == P2PMsg.getFromAccount()) {

					var msgData = JSON.parse(P2PMsg.getPayload())
					var msg = Base64.decode(msgData.payload)
					msg = JSON.parse(msg);
					var currenture = new Date().getTime();
					var t = (currenture - msgData.timestamp) / 24 / 60 / 60 / 1000
					if (t >= '1') {
						//过滤除了当天的消息
						return false
					}
					if (P2PMsg.getBizType() == 'TEXT') {
						msg.content = this.decodeUnicode(msg.content)
					}
					if (P2PMsg.getBizType() == 'PIC_FILE') {
						msg.url = this.decodeUnicode(msg.url)
					}
					if (P2PMsg.getBizType() == 'PIC_FILES') {
						msg.content = this.decodeUnicode(msg.content)
					}
					msg.show = true
					if (msg.show_type != undefined && msg.show_type != 'all') {
						msg.show = false
						msg.show_list = msg.show_list.substr(1)
						msg.show_list = msg.show_list.substr(0, msg.show_list.length - 1);
						msg.show_list = msg.show_list.split(',')
						msg.show_list.filter((item) => {
							if (item == this.myconNum) {
								msg.show = true
							}
						})
					}
					var say = {
						biz_type: P2PMsg.getBizType(),
						msg_from_nick: msgData.nickname,
						update_time: msgData.timestamp,
						msg_from_logo: msgData.logo,
						msg_id: msgData.msgId,
						msg_content: msg,
						msg_from_account: P2PMsg.getFromAccount()
					}
					this.infoData.list.push(say)
					this.$nextTick(() => {
						this.$refs.wrap.scrollTop = this.$refs.wrap.scrollHeight
					})
				}
			},
			ucMessage(P2TMsg) {
				//频道
				// return false
				if (this.myInfo.topId == P2TMsg.getTopicId()) {

					var msgData = JSON.parse(P2TMsg.getPayload())
					var msg = Base64.decode(msgData.payload)
					msg = JSON.parse(msg);
					var currenture = new Date().getTime();
					var t = (currenture - msgData.timestamp) / 24 / 60 / 60 / 1000
					if (t >= '1') {
						//过滤除了当天的消息
						return false
					}
					if (P2TMsg.getBizType() == 'TEXT') {
						msg.content = this.decodeUnicode(msg.content)
					}
					if (P2TMsg.getBizType() == 'PIC_FILE') {
						msg.url = this.decodeUnicode(msg.url)
					}
					if (P2TMsg.getBizType() == 'PIC_FILES') {
						msg.content = this.decodeUnicode(msg.content)
					}

					if (JSON.stringify(msg.reply) == '{}') {
						msg.reply = ''
					}
					if (msg.reply == undefined) {
						msg.reply = ''
					}

					if (msg.reply != '') {
						msg.reply = JSON.parse(msg.reply)
						msg.reply.msg_content = JSON.parse(msg.reply.msg_content)
						if (msg.reply.msg_content.content != undefined) {
							msg.reply.msg_content.content = this.decodeUnicode(msg.reply.msg_content.content)
						}
					}

					msg.show = true
					if (msg.show_type != undefined && msg.show_type != 'all') {
						msg.show = false
						msg.show_list = msg.show_list.substr(1)
						msg.show_list = msg.show_list.substr(0, msg.show_list.length - 1);
						msg.show_list = msg.show_list.split(',')
						msg.show_list.filter((item) => {
							if (item == this.myconNum) {
								msg.show = true
							}
						})
					}
					var say = {
						biz_type: P2TMsg.getBizType(),
						msg_from_nick: msgData.nickname,
						update_time: msgData.timestamp,
						msg_from_logo: msgData.logo,
						msg_id: msgData.msgId,
						msg_content: msg,
						msg_from_account: P2TMsg.getFromAccount()
					}

					this.infoData.list.push(say)
					this.$nextTick(() => {
						this.$refs.wrap.scrollTop = this.$refs.wrap.scrollHeight
					})
				}
			},
			emojiAdd(item) {
				this.myValue = this.myValue + item
			},
			createCode() {
				var code = '';
				//设置长度，这里看需求，我这里设置了4
				var codeLength = 4;

				//设置随机字符
				var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);

				//循环codeLength 我设置的4就是循环4次
				for (var i = 0; i < codeLength; i++) {
					//设置随机数范围,这设置为0 ~ 36
					var index = Math.floor(Math.random() * 9);

					//字符串拼接 将每次随机的字符 进行拼接
					code += random[index];
				}

				//将拼接好的字符串赋值给展示的code
				this.code = code;
			},
			ceshiyixia(res) {

				this.percentWenjian = "http://img.kh507.com/" + res.key;

				if (this.percentType.type2 == "mp3") {
					indexMsg += 1
					var reply = ''
					if (this.hfData != '') {
						if (this.hfData.msg_content.content != undefined) {
							this.hfData.msg_content.content = this.encodeUnicode(this.hfData.msg_content.content)
						}
						delete this.hfData.msg_content.reply
						reply = {
							id: this.hfData.msg_id,
							nick_name: this.hfData.msg_from_nick,
							logo: this.hfData.msg_from_logo,
							biz_type: this.hfData.biz_type,
							msg_content: this.hfData.msg_content,
						}
					}
					var show_list = ''
					var show_type = 'all'
					if (this.activeChecked) {
						show_type = 'list'
						show_list = '[' + JSON.parse(this.getCookie("userInfo")).conNum + ']'
					}
					var msg = { version: 1, reply: reply, show_list: show_list, show_type: show_type, song_title: res.key, song_url: this.percentWenjian, song_logo: 'http://img.kh507.com/1b49_1608798162596_53631', singer_title: '未知' }
					var message_ = Base64.encode(JSON.stringify(msg));
					var timestampUser = String(new Date().valueOf())
					var jsonMsg = String(JSON.stringify({
						version: 0,
						msgId: this.randomString(30) + "_" + indexMsg,
						timestamp: timestampUser,
						payload: message_,
						nickname: JSON.parse(this.getCookie("userInfo")).title,
						logo: JSON.parse(this.getCookie("userInfo")).logo,
						conNum: JSON.parse(this.getCookie("userInfo")).conNum
					}));



					if (this.myInfo.ms_type == '0') {
						this.user.sendMessage(this.myInfo.user, jsonMsg, "MUSIC");
					} else if (this.myInfo.ms_type == '1') {
						this.user.sendGroupMessage(this.myInfo.topId, jsonMsg, "MUSIC");
					} else {
						this.user.sendUnlimitedGroupMessage(this.myInfo.topId, jsonMsg, "MUSIC");
					}

					if (this.hfData != '') {
						if (reply.msg_content.content != undefined) {
							reply.msg_content.content = this.decodeUnicode(reply.msg_content.content)
						}
					}
					var say = {
						biz_type: 'MUSIC',
						update_time: timestampUser,
						msg_content: { version: 1, reply: reply, show_list: "", show_type: 'all', show: true, song_title: res.key, song_url: this.percentWenjian, song_logo: 'http://img.kh507.com/1b49_1608798162596_53631', singer_title: '未知' },
						msg_from_logo: JSON.parse(this.getCookie("userInfo")).logo,
						msg_from_nick: JSON.parse(this.getCookie("userInfo")).title,
						msg_from_account: JSON.parse(this.getCookie("userInfo")).account
					}
					this.myValue = ''
					this.hfData = ''
					this.percentType.type2 = ''
					this.infoData.list.push(say)
					this.$nextTick(() => {
						this.$refs.wrap.scrollTop = this.$refs.wrap.scrollHeight
					})
				}
				if (this.percentType.type3 == "mp4") {
					indexMsg += 1
					var reply = ''
					if (this.hfData != '') {
						if (this.hfData.msg_content.content != undefined) {
							this.hfData.msg_content.content = this.encodeUnicode(this.hfData.msg_content.content)
						}
						delete this.hfData.msg_content.reply
						reply = {
							id: this.hfData.msg_id,
							nick_name: this.hfData.msg_from_nick,
							logo: this.hfData.msg_from_logo,
							biz_type: this.hfData.biz_type,
							msg_content: this.hfData.msg_content,
						}
					}
					var show_list = ''
					var show_type = 'all'
					if (this.activeChecked) {
						show_type = 'list'
						show_list = '[' + JSON.parse(this.getCookie("userInfo")).conNum + ']'
					}
					var msg = { content: '', url: this.percentWenjian, version: 1, reply: reply, show_list: show_list, show_type: show_type }
					var message_ = Base64.encode(JSON.stringify(msg));
					var timestampUser = String(new Date().valueOf())
					var jsonMsg = String(JSON.stringify({
						version: 0,
						msgId: this.randomString(30) + "_" + indexMsg,
						timestamp: timestampUser,
						payload: message_,
						nickname: JSON.parse(this.getCookie("userInfo")).title,
						logo: JSON.parse(this.getCookie("userInfo")).logo,
						conNum: JSON.parse(this.getCookie("userInfo")).conNum
					}));



					if (this.myInfo.ms_type == '0') {
						this.user.sendMessage(this.myInfo.user, jsonMsg, "VIDEO_FILE");
					} else if (this.myInfo.ms_type == '1') {
						this.user.sendGroupMessage(this.myInfo.topId, jsonMsg, "VIDEO_FILE");
					} else {
						this.user.sendUnlimitedGroupMessage(this.myInfo.topId, jsonMsg, "VIDEO_FILE");
					}

					if (this.hfData != '') {
						if (reply.msg_content.content != undefined) {
							reply.msg_content.content = this.decodeUnicode(reply.msg_content.content)
						}
					}
					var say = {
						biz_type: 'VIDEO_FILE',
						update_time: timestampUser,
						msg_content: { content: '', url: this.percentWenjian, version: 1, reply: reply, show_list: show_list, show_type: show_type, show: true },
						msg_from_logo: JSON.parse(this.getCookie("userInfo")).logo,
						msg_from_nick: JSON.parse(this.getCookie("userInfo")).title,
						msg_from_account: JSON.parse(this.getCookie("userInfo")).account
					}
					this.myValue = ''
					this.hfData = ''
					this.percentType.type3 = ''
					this.infoData.list.push(say)
					this.$nextTick(() => {
						this.$refs.wrap.scrollTop = this.$refs.wrap.scrollHeight
					})

				}
				if (this.percentType.type1 == "img") {
					indexMsg += 1
					var reply = ''
					if (this.hfData != '') {
						if (this.hfData.msg_content.content != undefined) {
							this.hfData.msg_content.content = this.encodeUnicode(this.hfData.msg_content.content)
						}
						delete this.hfData.msg_content.reply
						reply = {
							id: this.hfData.msg_id,
							nick_name: this.hfData.msg_from_nick,
							logo: this.hfData.msg_from_logo,
							biz_type: this.hfData.biz_type,
							msg_content: this.hfData.msg_content,
						}
					}
					var show_list = ''
					var show_type = 'all'
					if (this.activeChecked) {
						show_type = 'list'
						show_list = '[' + JSON.parse(this.getCookie("userInfo")).conNum + ']'
					}
					var msg = { content: '', images: [this.percentWenjian], version: 1, reply: reply, show_list: show_list, show_type: show_type }
					var message_ = Base64.encode(JSON.stringify(msg));
					var timestampUser = String(new Date().valueOf())
					var jsonMsg = String(JSON.stringify({
						version: 0,
						msgId: this.randomString(30) + "_" + indexMsg,
						timestamp: timestampUser,
						payload: message_,
						nickname: JSON.parse(this.getCookie("userInfo")).title,
						logo: JSON.parse(this.getCookie("userInfo")).logo,
						conNum: JSON.parse(this.getCookie("userInfo")).conNum
					}));



					if (this.myInfo.ms_type == '0') {
						this.user.sendMessage(this.myInfo.user, jsonMsg, "PIC_FILES");
					} else if (this.myInfo.ms_type == '1') {
						this.user.sendGroupMessage(this.myInfo.topId, jsonMsg, "PIC_FILES");
					} else {
						this.user.sendUnlimitedGroupMessage(this.myInfo.topId, jsonMsg, "PIC_FILES");
					}

					if (this.hfData != '') {
						if (reply.msg_content.content != undefined) {
							reply.msg_content.content = this.decodeUnicode(reply.msg_content.content)
						}
					}
					var say = {
						biz_type: 'PIC_FILES',
						update_time: timestampUser,
						msg_content: { content: '', images: [this.percentWenjian], version: 1, reply: reply, show_list: show_list, show_type: show_type, show: true },
						msg_from_logo: JSON.parse(this.getCookie("userInfo")).logo,
						msg_from_nick: JSON.parse(this.getCookie("userInfo")).title,
						msg_from_account: JSON.parse(this.getCookie("userInfo")).account
					}
					this.myValue = ''
					this.hfData = ''
					this.percentType.type1 = ''
					this.infoData.list.push(say)
					this.$nextTick(() => {
						this.$refs.wrap.scrollTop = this.$refs.wrap.scrollHeight
					})
				}
				if (this.percentType.type4 == "other") {
					indexMsg += 1
					var reply = ''
					if (this.hfData != '') {
						if (this.hfData.msg_content.content != undefined) {
							this.hfData.msg_content.content = this.encodeUnicode(this.hfData.msg_content.content)
						}
						delete this.hfData.msg_content.reply
						reply = {
							id: this.hfData.msg_id,
							nick_name: this.hfData.msg_from_nick,
							logo: this.hfData.msg_from_logo,
							biz_type: this.hfData.biz_type,
							msg_content: this.hfData.msg_content,
						}
					}

					var show_list = ''
					var show_type = 'all'
					if (this.activeChecked) {
						show_type = 'list'
						show_list = '[' + JSON.parse(this.getCookie("userInfo")).conNum + ']'
					}
					var msg = { url: this.percentWenjian, urlName: res.key, version: 1, reply: reply, show_list: show_list, show_type: show_type }
					var message_ = Base64.encode(JSON.stringify(msg));
					var timestampUser = String(new Date().valueOf())
					var jsonMsg = String(JSON.stringify({
						version: 0,
						msgId: this.randomString(30) + "_" + indexMsg,
						timestamp: timestampUser,
						payload: message_,
						nickname: JSON.parse(this.getCookie("userInfo")).title,
						logo: JSON.parse(this.getCookie("userInfo")).logo,
						conNum: JSON.parse(this.getCookie("userInfo")).conNum
					}));



					if (this.myInfo.ms_type == '0') {
						this.user.sendMessage(this.myInfo.user, jsonMsg, "FILE");
					} else if (this.myInfo.ms_type == '1') {
						this.user.sendGroupMessage(this.myInfo.topId, jsonMsg, "FILE");
					} else {
						this.user.sendUnlimitedGroupMessage(this.myInfo.topId, jsonMsg, "FILE");
					}

					if (this.hfData != '') {
						if (reply.msg_content.content != undefined) {
							reply.msg_content.content = this.decodeUnicode(reply.msg_content.content)
						}
					}
					var say = {
						biz_type: 'FILE',
						update_time: timestampUser,
						msg_content: { url: this.percentWenjian, urlName: res.key, version: 1, reply: reply, show_list: show_list, show_type: show_type, show: true },
						msg_from_logo: JSON.parse(this.getCookie("userInfo")).logo,
						msg_from_nick: JSON.parse(this.getCookie("userInfo")).title,
						msg_from_account: JSON.parse(this.getCookie("userInfo")).account
					}
					this.myValue = ''
					this.hfData = ''
					this.percentType.type4 = ''
					this.infoData.list.push(say)
					this.$nextTick(() => {
						this.$refs.wrap.scrollTop = this.$refs.wrap.scrollHeight
					})

				}

			},

			shangchuan(file) {
				let config = {
					useCdnDomain: false,
					region: qiniu.region.z1
				};
				let putExtra = {
					fname: this.file,
					params: {},
					mimeType: null
				};

				let observe = {
					next: (res) => {
						// console.log('已上传大小，单位为字节：' + res.total.loaded)
						// console.log('本次上传的总量控制信息，单位为字节：' + res.total.size)
						// console.log('当前上传进度，范围：0～100：' + res.total.percent);

					},
					error(err) {
						// console.log(1,err.code)
						// console.log(2,err.message)
						// console.log(3,err.isRequestError)
						// console.log(4,err.reqId)
					},
					complete: (res) => {
						//完成后的操作
						//上传成功以后会返回key 和 hash  key就是文件名了！

						this.jishu = this.jishu + 1

						if (this.jishu == this.fileData.length) {
							this.fileData = []
						}
						if (file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif") {

							this.percentType.name = this.keys //file.name;
							this.percentType.type1 = "img"
						} else if (file.type === "audio/mp3" || file.type === "audio/mpeg") {

							this.percentType.type2 = "mp3"
						} else if (file.type === "video/mp4") {

							this.percentType.name = this.keys //file.name;
							this.percentType.type3 = "mp4"
						} else {
							this.percentType.type4 = "other"

						}
						this.ceshiyixia(res)



					}
				};

				//开始上传  token 需要找后端获取(单独的方法)
				let observable = qiniu.upload(this.file, this.keys, this.getToken(), putExtra, config)
				let subscription = observable.subscribe(observe)
			},
			//回车发送
			enterSearch(e) {
				document.onkeydown = e => {
					//13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
					if (e.keyCode === 13) {
						e.preventDefault()
						if (this.myValue == '') {
							this.$message.error('发送内容不能为空');
							return false
						} else {
							this.sendValue(e)
						}
						//回车后执行搜索方法

					}
				}
			},
			sendValue(e) {

				if (this.myValue == '' && this.fileData == '') {
					this.$message.error('请输入内容');
					return false
				}
				if (this.myValue == '' && this.fileData != '') {
					for (let i = 0; i < this.fileData.length; i++) {
						// this.beforeUpload(this.fileData[i])
						this.file = this.fileData[i]; // 对象，上传的文件
						this.keys = 'file/mimc/' + this.times() + "/" + this.file.name;
						// var key = this.fileData[i].name; // 文件资源名

						this.shangchuan(this.file)
					}
					return false
				}
				for (let i = 0; i < this.fileData.length; i++) {
					// this.beforeUpload(this.fileData[i])
					this.file = this.fileData[i]; // 对象，上传的文件
					this.keys = 'file/mimc/' + this.times() + "/" + this.file.name;
					// var key = this.fileData[i].name; // 文件资源名

					this.shangchuan(this.file)
				}

				/*
				* config.useCdnDomain: 是否使用 cdn 加速域名，true or false，默认为 false。
				* config.disableStatisticsReport: 是否禁用日志报告，为布尔值，默认为false。
				* config.region: 选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域
				* config.retryCount: 上传自动重试次数（整体重试次数）；默认3次（即上传失败后最多重试两次）；
				* config.concurrentRequestLimit: 分片上传的并发请求量，number，默认为3；
				* config.checkByMD5: 是否开启 MD5 校验，在断点续传时校验分片，默认为 false，不开启。
				*/
				/*
				* fname: string，文件原文件名.
				* params: object，用来放置自定义变量;
				* mimeType: null || array，用来限制上传文件类型，为 null 时表示不对文件类型限制；
				* 限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
				 */




				this.createCode()

				indexMsg += 1
				var reply = ''

				if (this.hfData != '') {
					if (this.hfData.msg_content.content != undefined) {
						this.hfData.msg_content.content = this.encodeUnicode(this.hfData.msg_content.content)
					}
					delete this.hfData.msg_content.reply
					reply = {
						id: this.hfData.msg_id,
						nick_name: this.hfData.msg_from_nick,
						logo: this.hfData.msg_from_logo,
						biz_type: this.hfData.biz_type,
						msg_content: this.hfData.msg_content,
					}
				}

				var show_list = ''
				var show_type = 'all'
				if (this.activeChecked) {
					show_type = 'list'
					show_list = '[' + JSON.parse(this.getCookie("userInfo")).conNum + ']'
				}

				var msg = { content: this.encodeUnicode(this.myValue), version: 1, reply: reply, show_type: show_type, show_list: show_list }
				var message_ = Base64.encode(JSON.stringify(msg));
				var timestampUser = String(new Date().valueOf())

				var jsonMsg = String(JSON.stringify({
					version: 0,
					//   msgId: this.randomString(30)+"_"+indexMsg, 
					msgId: JSON.parse(this.getCookie("userInfo")).conNum + this.myInfo.msg_to + timestampUser + this.code,
					timestamp: timestampUser,
					payload: message_,
					nickname: JSON.parse(this.getCookie("userInfo")).title,
					logo: JSON.parse(this.getCookie("userInfo")).logo,
					conNum: JSON.parse(this.getCookie("userInfo")).conNum
				}));
				if (this.myInfo.ms_type == '0') {
					this.user.sendMessage(this.myInfo.user, jsonMsg, "TEXT");
				} else if (this.myInfo.ms_type == '1') {
					this.user.sendGroupMessage(this.myInfo.topId, jsonMsg, "TEXT");
				} else {
					this.user.sendUnlimitedGroupMessage(this.myInfo.topId, jsonMsg, "TEXT");
				}
				if (this.hfData != '') {
					if (reply.msg_content.content != undefined) {
						reply.msg_content.content = this.decodeUnicode(reply.msg_content.content)
					}
				}

				var id = 0;
				if (this.infoData.list.length > 0) {
					id = this.infoData.list[this.infoData.list.length - 1].id + 1
				}

				var say = {
					id: id,
					biz_type: 'TEXT',
					update_time: timestampUser,
					msg_content: { content: this.myValue, version: 1, reply: reply, show_type: show_type, show_list: show_list, show: true },
					msg_from_logo: JSON.parse(this.getCookie("userInfo")).logo,
					msg_from_nick: JSON.parse(this.getCookie("userInfo")).title,
					msg_from_account: JSON.parse(this.getCookie("userInfo")).account
				}

				this.myValue = ''
				this.hfData = ''
				this.infoData.list.push(say)
				this.$nextTick(() => {
					this.$refs.wrap.scrollTop = this.$refs.wrap.scrollHeight
				})





			},

			playY(id) {
				for (var i = 0; i < this.$refs.video.length; i++) {

					if (this.$refs.video[i].id != id) {
						this.$refs.video[i].pause()
					}
				}
			},
			beforeAvatarUpload(file) {
				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/file/v1/getQiNiuToken')
					.then(userData => {
						if (userData.data.resultCode == "0000") {
							var uptoken = userData.data.resultInfo
							this.uploadImg(file, uptoken)
						} else if (userData.data.resultCode == "1313") {
							this.$parent.loginto();
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})
				return false;
			},
			uploadImg(files, uptoken) {
				var config = { useCdnDomain: false, region: null };
				var putExtra = {
					fname: "main_index_ormal",
					params: {},
					mimeType: ["image/png", "image/jpeg", "image/gif"]
				};
				var _self = this

				var observer = {
					next(res) {

					},
					error(err) {
						_self.$message.error("上传失败");
					},
					complete(res) {
						indexMsg += 1
						var myurl = 'http://img.kh507.com/' + res.key
						var message_ = Base64.encode(myurl);
						var timestampUser = String(new Date().valueOf())
						var jsonMsg = String(JSON.stringify({
							version: 0,
							msgId: _self.randomString(5) + "_" + indexMsg,
							timestamp: timestampUser,
							payload: message_,
							nickname: JSON.parse(_self.getCookie("userInfo")).title,
							logo: JSON.parse(_self.getCookie("userInfo")).logo,
							conNum: JSON.parse(_self.getCookie("userInfo")).conNum
						}));


						if (_self.myInfo.ms_type == '0') {
							_self.user.sendMessage(_self.myInfo.user, jsonMsg, "PIC_FILE");
						} else {
							_self.user.sendGroupMessage(_self.myInfo.topId, jsonMsg, "PIC_FILE");
						}


						var say = {
							biz_type: 'PIC_FILE',
							msg_from_nick: JSON.parse(_self.getCookie("userInfo")).title,
							update_time: timestampUser,
							msg_from_logo: JSON.parse(_self.getCookie("userInfo")).logo,
							msg_content: myurl,
							msg_from_account: JSON.parse(_self.getCookie("userInfo")).account
						}

						_self.infoData.list.push(say)
						setTimeout(() => {
							_self.$refs.wrap.scrollTop = _self.$refs.wrap.scrollHeight
						}, 30)

					}
				}
				var name = _self.createRandomId();
				var observable = qiniu.upload(files, name, uptoken, putExtra, config)
				var subscription = observable.subscribe(observer) // 上传开始
			},
			createRandomId() {
				return (Math.random() * 10000000).toString(16).substr(0, 4) + '_' + (new Date()).getTime() + '_' + Math.random().toString().substr(2, 5);
			},
			setcookie(name, value) {
				//设置名称为name,值为value的Cookie
				var expdate = new Date();   //初始化时间
				expdate.setTime(expdate.getTime() + 24 * 7 * 60 * 60 * 1000);   //时间单位毫秒 过期时间30分钟
				document.cookie = name + "=" + value + ";expires=" + expdate.toGMTString() + ";path=/";

				//即document.cookie= name+"="+value+";path=/";  时间默认为当前会话可以不要，但路径要填写，因为JS的默认路径是当前页，如果不填，此cookie只在当前页面生效！
			},
			getCookie(c_name) {
				//判断document.cookie对象里面是否存有cookie
				if (document.cookie.length > 0) {
					var c_start = document.cookie.indexOf(c_name + "=")
					//如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
					if (c_start != -1) {
						c_start = c_start + c_name.length + 1
						var c_end = document.cookie.indexOf(";", c_start)
						if (c_end == -1) c_end = document.cookie.length
						return unescape(unescape(document.cookie.substring(c_start, c_end)))
					}
				}
				return ""
			},
			moreMenu(data, index) {
				if (data.biz_type == 'FILE' || data.biz_type == 'BOTPAY') {
					return false
				}
				this.menushow = index
			},
			sendQun(index, data) {


				this.menushow = false
				this.sendQunData = JSON.parse(JSON.stringify(data))
				this.sendQunData.ms_type = '1'
				this.qunShow = true
				setTimeout(() => {
					this.$refs.mychildQun.getData(this.sendQunData);
				}, 50)
			},
			sendPindao(index, data) {


				this.menushow = false
				this.sendQunData = JSON.parse(JSON.stringify(data))
				this.sendQunData.ms_type = '2'
				this.qunShow = true
				setTimeout(() => {
					this.$refs.mychildQun.getData(this.sendQunData);
				}, 50)
			},


			// 回复
			hfFC(data) {
				this.hfData = JSON.parse(JSON.stringify(data))
				this.menushow = false
			},
			cheHui(index, data) {
				this.menushow = false
				this.del(index, data)
			},
			del(index, data) {

				if (data.id == undefined || data.id == null || data.id == '') {
					this.$message.error("请刷新重试");
					return false
				}
				let params = qs.stringify({
					id: data.id,
				})

				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/v1/revokeMsg', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							this.infoData.list.splice(index, 1);
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})
			},
			jubao(index, data) {
				this.dialogJbao = true
				this.jubaoData = data
			},
			jubaoFC(data) {
				if (this.jubaoData.id == undefined || this.jubaoData.id == null || this.jubaoData.id == '') {
					this.$message.error("请刷新重试");
					return false
				}
				let params = qs.stringify({
					report_type: data,
					report_msg_id: this.jubaoData.id
				})

				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/v1/reportMsg', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							this.dialogJbao = false
							this.$message('已举报');
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})
			},
			closehf() {
				this.hfData = ''
			},
			closeQun() {
				this.qunShow = false
				this.bindAIShow = false
				this.aiShow = false
			},

			/*卡片*/

			check(data) {
				this.$parent.cardbox(data)
			},
			/*上传文件开始*/
			times() {
				var code = "";
				for (var i = 1; i <= 6; i++) {
					const num = Math.floor(Math.random() * 10);
					code += num;
				};
				var timestamp = (new Date()).valueOf();
				return timestamp + code
			},
			randomString(len) {
				len = len || 8;
				var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
				var maxPos = $chars.length;
				var pwd = '';
				for (var i = 0; i < len; i++) {
					pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
				}
				var date = new Date();
				var time = date.toLocaleDateString().replace(/\//g, "")
				return "kh_usera_" + time + "_" + pwd;
			},
			handlePro(res) { //上传进度
				this.percent = res.percent
			},
			handleError(res) { //上传失败
				this.$message.error('文件上传失败');
			},
			beforeUpload(file) { //上传文件之前
				//   this.qn.key = this.randomString(8)+"-"+file.name;        // 通过设置key为文件名，上传到七牛中会显示对应的图片名
				this.qn.key = 'file/mimc/' + this.times() + "/" + file.name;
				this.qn.token = this.getToken()
				this.percentType.name = this.qn.key //file.name;
				if (file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif") {
					var flieArr = file.name.split('.');
					this.suffix = flieArr[flieArr.length - 1]
					this.qn.key = 'images/mimc/' + this.times() + "." + this.suffix;
					this.qn.token = this.getToken()
					this.percentType.name = this.qn.key //file.name;
					this.percentType.type = "img"
				} else if (file.type === "audio/mp3" || file.type === "audio/mpeg") {
					var flieArr = file.name.split('.');
					this.suffix = flieArr[flieArr.length - 1]
					this.qn.key = 'audio/mimc/' + this.times() + "." + this.suffix;
					this.qn.token = this.getToken()
					this.percentType.name = this.qn.key //file.name;
					this.percentType.type = "mp3"
				} else if (file.type === "video/mp4") {
					var flieArr = file.name.split('.');
					this.suffix = flieArr[flieArr.length - 1]
					this.qn.key = 'video/mimc/' + this.times() + "." + this.suffix;
					this.qn.token = this.getToken()
					this.percentType.name = this.qn.key //file.name;
					this.percentType.type = "mp4"
				} else {
					this.percentType.type = "other"
				}
				return true;
			},
			getToken() { //获取token
				$.ajax({
					type: "POST",
					url: '/goods/file/v1/getQiNiuToken',
					async: false, //设为false就是同步请求
					cache: false,
					success: (res) => {
						if (res.resultCode = '0000') {
							this.token = res.resultInfo
						} else {
							this.$message.error('token获取失败');
						}
					}
				});
				return this.token
			},
			handleSuccess(res, file) {//上传成功
				this.percentWenjian = "http://img.kh507.com/" + res.key;
				if (this.percentType.type == "mp3") {
					indexMsg += 1
					var reply = ''
					if (this.hfData != '') {
						if (this.hfData.msg_content.content != undefined) {
							this.hfData.msg_content.content = this.encodeUnicode(this.hfData.msg_content.content)
						}
						delete this.hfData.msg_content.reply
						reply = {
							id: this.hfData.msg_id,
							nick_name: this.hfData.msg_from_nick,
							logo: this.hfData.msg_from_logo,
							biz_type: this.hfData.biz_type,
							msg_content: this.hfData.msg_content,
						}
					}
					var show_list = ''
					var show_type = 'all'
					if (this.activeChecked) {
						show_type = 'list'
						show_list = '[' + JSON.parse(this.getCookie("userInfo")).conNum + ']'
					}
					var msg = { version: 1, reply: reply, show_list: show_list, show_type: show_type, song_title: this.percentType.name, song_url: this.percentWenjian, song_logo: 'http://img.kh507.com/1b49_1608798162596_53631', singer_title: '未知' }
					var message_ = Base64.encode(JSON.stringify(msg));
					var timestampUser = String(new Date().valueOf())
					var jsonMsg = String(JSON.stringify({
						version: 0,
						msgId: this.randomString(30) + "_" + indexMsg,
						timestamp: timestampUser,
						payload: message_,
						nickname: JSON.parse(this.getCookie("userInfo")).title,
						logo: JSON.parse(this.getCookie("userInfo")).logo,
						conNum: JSON.parse(this.getCookie("userInfo")).conNum
					}));



					if (this.myInfo.ms_type == '0') {
						this.user.sendMessage(this.myInfo.user, jsonMsg, "MUSIC");
					} else if (this.myInfo.ms_type == '1') {
						this.user.sendGroupMessage(this.myInfo.topId, jsonMsg, "MUSIC");
					} else {
						this.user.sendUnlimitedGroupMessage(this.myInfo.topId, jsonMsg, "MUSIC");
					}

					if (this.hfData != '') {
						if (reply.msg_content.content != undefined) {
							reply.msg_content.content = this.decodeUnicode(reply.msg_content.content)
						}
					}
					var say = {
						biz_type: 'MUSIC',
						update_time: timestampUser,
						msg_content: { version: 1, reply: reply, show_list: "", show_type: 'all', show: true, song_title: this.percentType.name, song_url: this.percentWenjian, song_logo: 'http://img.kh507.com/1b49_1608798162596_53631', singer_title: '未知' },
						msg_from_logo: JSON.parse(this.getCookie("userInfo")).logo,
						msg_from_nick: JSON.parse(this.getCookie("userInfo")).title,
						msg_from_account: JSON.parse(this.getCookie("userInfo")).account
					}
					this.myValue = ''
					this.hfData = ''
					this.infoData.list.push(say)
					this.$nextTick(() => {
						this.$refs.wrap.scrollTop = this.$refs.wrap.scrollHeight
					})
				}
				if (this.percentType.type == "mp4") {
					indexMsg += 1
					var reply = ''
					if (this.hfData != '') {
						if (this.hfData.msg_content.content != undefined) {
							this.hfData.msg_content.content = this.encodeUnicode(this.hfData.msg_content.content)
						}
						delete this.hfData.msg_content.reply
						reply = {
							id: this.hfData.msg_id,
							nick_name: this.hfData.msg_from_nick,
							logo: this.hfData.msg_from_logo,
							biz_type: this.hfData.biz_type,
							msg_content: this.hfData.msg_content,
						}
					}
					var show_list = ''
					var show_type = 'all'
					if (this.activeChecked) {
						show_type = 'list'
						show_list = '[' + JSON.parse(this.getCookie("userInfo")).conNum + ']'
					}
					var msg = { content: '', url: this.percentWenjian, version: 1, reply: reply, show_list: show_list, show_type: show_type }
					var message_ = Base64.encode(JSON.stringify(msg));
					var timestampUser = String(new Date().valueOf())
					var jsonMsg = String(JSON.stringify({
						version: 0,
						msgId: this.randomString(30) + "_" + indexMsg,
						timestamp: timestampUser,
						payload: message_,
						nickname: JSON.parse(this.getCookie("userInfo")).title,
						logo: JSON.parse(this.getCookie("userInfo")).logo,
						conNum: JSON.parse(this.getCookie("userInfo")).conNum
					}));



					if (this.myInfo.ms_type == '0') {
						this.user.sendMessage(this.myInfo.user, jsonMsg, "VIDEO_FILE");
					} else if (this.myInfo.ms_type == '1') {
						this.user.sendGroupMessage(this.myInfo.topId, jsonMsg, "VIDEO_FILE");
					} else {
						this.user.sendUnlimitedGroupMessage(this.myInfo.topId, jsonMsg, "VIDEO_FILE");
					}

					if (this.hfData != '') {
						if (reply.msg_content.content != undefined) {
							reply.msg_content.content = this.decodeUnicode(reply.msg_content.content)
						}
					}
					var say = {
						biz_type: 'VIDEO_FILE',
						update_time: timestampUser,
						msg_content: { content: '', url: this.percentWenjian, version: 1, reply: reply, show_list: show_list, show_type: show_type, show: true },
						msg_from_logo: JSON.parse(this.getCookie("userInfo")).logo,
						msg_from_nick: JSON.parse(this.getCookie("userInfo")).title,
						msg_from_account: JSON.parse(this.getCookie("userInfo")).account
					}
					this.myValue = ''
					this.hfData = ''
					this.infoData.list.push(say)
					this.$nextTick(() => {
						this.$refs.wrap.scrollTop = this.$refs.wrap.scrollHeight
					})
				}
				if (this.percentType.type == "img") {
					indexMsg += 1
					var reply = ''
					if (this.hfData != '') {
						if (this.hfData.msg_content.content != undefined) {
							this.hfData.msg_content.content = this.encodeUnicode(this.hfData.msg_content.content)
						}
						delete this.hfData.msg_content.reply
						reply = {
							id: this.hfData.msg_id,
							nick_name: this.hfData.msg_from_nick,
							logo: this.hfData.msg_from_logo,
							biz_type: this.hfData.biz_type,
							msg_content: this.hfData.msg_content,
						}
					}
					var show_list = ''
					var show_type = 'all'
					if (this.activeChecked) {
						show_type = 'list'
						show_list = '[' + JSON.parse(this.getCookie("userInfo")).conNum + ']'
					}
					var msg = { content: '', images: [this.percentWenjian], version: 1, reply: reply, show_list: show_list, show_type: show_type }
					var message_ = Base64.encode(JSON.stringify(msg));
					var timestampUser = String(new Date().valueOf())
					var jsonMsg = String(JSON.stringify({
						version: 0,
						msgId: this.randomString(30) + "_" + indexMsg,
						timestamp: timestampUser,
						payload: message_,
						nickname: JSON.parse(this.getCookie("userInfo")).title,
						logo: JSON.parse(this.getCookie("userInfo")).logo,
						conNum: JSON.parse(this.getCookie("userInfo")).conNum
					}));



					if (this.myInfo.ms_type == '0') {
						this.user.sendMessage(this.myInfo.user, jsonMsg, "PIC_FILES");
					} else if (this.myInfo.ms_type == '1') {
						this.user.sendGroupMessage(this.myInfo.topId, jsonMsg, "PIC_FILES");
					} else {
						this.user.sendUnlimitedGroupMessage(this.myInfo.topId, jsonMsg, "PIC_FILES");
					}

					if (this.hfData != '') {
						if (reply.msg_content.content != undefined) {
							reply.msg_content.content = this.decodeUnicode(reply.msg_content.content)
						}
					}
					var say = {
						biz_type: 'PIC_FILES',
						update_time: timestampUser,
						msg_content: { content: '', images: [this.percentWenjian], version: 1, reply: reply, show_list: show_list, show_type: show_type, show: true },
						msg_from_logo: JSON.parse(this.getCookie("userInfo")).logo,
						msg_from_nick: JSON.parse(this.getCookie("userInfo")).title,
						msg_from_account: JSON.parse(this.getCookie("userInfo")).account
					}
					this.myValue = ''
					this.hfData = ''
					this.infoData.list.push(say)
					this.$nextTick(() => {
						this.$refs.wrap.scrollTop = this.$refs.wrap.scrollHeight
					})
				}
				if (this.percentType.type == "other") {
					indexMsg += 1
					var reply = ''
					if (this.hfData != '') {
						if (this.hfData.msg_content.content != undefined) {
							this.hfData.msg_content.content = this.encodeUnicode(this.hfData.msg_content.content)
						}
						delete this.hfData.msg_content.reply
						reply = {
							id: this.hfData.msg_id,
							nick_name: this.hfData.msg_from_nick,
							logo: this.hfData.msg_from_logo,
							biz_type: this.hfData.biz_type,
							msg_content: this.hfData.msg_content,
						}
					}

					var show_list = ''
					var show_type = 'all'
					if (this.activeChecked) {
						show_type = 'list'
						show_list = '[' + JSON.parse(this.getCookie("userInfo")).conNum + ']'
					}
					var msg = { url: this.percentWenjian, urlName: this.percentType.name, version: 1, reply: reply, show_list: show_list, show_type: show_type }
					var message_ = Base64.encode(JSON.stringify(msg));
					var timestampUser = String(new Date().valueOf())
					var jsonMsg = String(JSON.stringify({
						version: 0,
						msgId: this.randomString(30) + "_" + indexMsg,
						timestamp: timestampUser,
						payload: message_,
						nickname: JSON.parse(this.getCookie("userInfo")).title,
						logo: JSON.parse(this.getCookie("userInfo")).logo,
						conNum: JSON.parse(this.getCookie("userInfo")).conNum
					}));



					if (this.myInfo.ms_type == '0') {
						this.user.sendMessage(this.myInfo.user, jsonMsg, "FILE");
					} else if (this.myInfo.ms_type == '1') {
						this.user.sendGroupMessage(this.myInfo.topId, jsonMsg, "FILE");
					} else {
						this.user.sendUnlimitedGroupMessage(this.myInfo.topId, jsonMsg, "FILE");
					}

					if (this.hfData != '') {
						if (reply.msg_content.content != undefined) {
							reply.msg_content.content = this.decodeUnicode(reply.msg_content.content)
						}
					}
					var say = {
						biz_type: 'FILE',
						update_time: timestampUser,
						msg_content: { url: this.percentWenjian, urlName: this.percentType.name, version: 1, reply: reply, show_list: show_list, show_type: show_type, show: true },
						msg_from_logo: JSON.parse(this.getCookie("userInfo")).logo,
						msg_from_nick: JSON.parse(this.getCookie("userInfo")).title,
						msg_from_account: JSON.parse(this.getCookie("userInfo")).account
					}
					this.myValue = ''
					this.hfData = ''
					this.infoData.list.push(say)
					this.$nextTick(() => {
						this.$refs.wrap.scrollTop = this.$refs.wrap.scrollHeight
					})
				}
			},
			change() {
				this.activeChecked = !this.activeChecked
				if (this.activeChecked) {
					this.textChange = "隐私模式下发送的内容仅自己可看"
				} else {
					this.textChange = ""
				}
			},
			/*上传文件结束*/
			//   aiHXC(){
			//   			let params = qs.stringify({
			// 				  	group_no:this.myInfo.msg_to,
			// 			})

			//   			this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
			// 			this.$axios.post('/goods/mimc/robot/getBotWakeWord/v2',params) 
			// 			.then(userData=>{
			// 				if(userData.data.resultCode=='0000'){
			// 					this.aihuanxingci=userData.data.resultInfo
			// 		        }else{
			//    					this.$message.error(userData.data.resultMsg);
			// 		        }				   
			// 			}).catch(error=>{
			// 				console.log(error)
			// 			}) 	  	
			//   },  	
			// aigo(data){
			// 	this.aiShow=false
			// 	this.myValue=data
			// }, 
			tianci(data) {
				this.myValue = data
			},
			// 	bindYes() {
			// 			  		let params = qs.stringify({
			// 							  	group_no:this.myInfo.msg_to,
			// 						})	
			// 	  return  this.$axios.post('/goods/mimc/robot/queryRobot/v1',params);
			// 	},
			// 	binNo() {
			// 	  return this.$axios.post('/goods/mimc/robot/queryRobotInfos/v1');
			// 	},  	
			//   bindAI(){

			// 		this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")	  	
			// 		this.$axios.all([this.bindYes(), this.binNo()])
			// 		.then(this.$axios.spread((bindYesInfo, binNoInfo)=>{

			// 				if(bindYesInfo.data.resultCode=='0000'&&binNoInfo.data.resultCode=='0000'){
			// 					this.bindYesData=bindYesInfo.data.resultInfo
			// 					this.bindNoData=binNoInfo.data.resultInfo
			//         }else{
			// 						this.$message.error("机器人列表获取失败");
			//         }					
			// 		}));	  	
			//   },  	
			//   bangding(data){
			// 			var type=''
			// 			if(this.myInfo.ms_type=='1'){
			// 				type='group'
			// 			}else{

			// 				type='channel'
			// 			}	  	

			//   			let params = qs.stringify({
			// 				  	relation_code:data.relation_code,
			// 				  	group_no:this.myInfo.msg_to,
			// 				  	type:type
			// 			})

			//   			this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
			// 			this.$axios.post('/goods/mimc/robot/relation/v1',params) 
			// 			.then(userData=>{
			// 				this.aiHXC()
			// 						if(userData.data.resultCode=='0000'){
			// 							this.$message("绑定成功");
			// 		        }else{
			//    					this.$message.error(userData.data.resultMsg);
			// 		        }				
			// 		        this.bindAI()
			// 			}).catch(error=>{
			// 				console.log(error)
			// 			}) 	  	
			//   },   	
			//   jiebang(data){
			//   			let params = qs.stringify({
			// 				  	id:data.id,
			// 			})

			//   			this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
			// 			this.$axios.post('/goods/mimc/robot/unrelation/v1',params) 
			// 			.then(userData=>{
			// 				    if(userData.data.resultCode=='0000'){
			// 							this.$message("已解除绑定");
			// 		        }else{
			//    					this.$message.error(userData.data.resultMsg);
			// 		        }		
			// 		        this.bindAI()
			// 			}).catch(error=>{
			// 				console.log(error)
			// 			}) 	  	
			//   },  	


		},
		created: function () {
			this.enterSearch()
			document.addEventListener('paste', this.getClipboardFiles)
		},
		filters: {
			length18(data) {
				if (data.length < 18) {
					return data
				} {
					var str = data.substring(0, 15) + "...";
					return str
				}
			},
			tows: function (data) {
				return (data / 100).toFixed(2)
			},
			coupons(data) {

			},
			timestamp(data) {
				data = data + ''
				if (data.indexOf('-') != '-1') {
					let d = new Date(data)
					data = d.getTime(d)
				}

				var dateCurrent = new Date();
				var yCurrent = dateCurrent.getFullYear();
				var mCurrent = dateCurrent.getMonth() + 1;
				var dCurrent = dateCurrent.getDate();
				var date = new Date(parseInt(data));//时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var Y = date.getFullYear();
				var M = date.getMonth() + 1;
				var D = date.getDate();
				var h = date.getHours();
				var m = date.getMinutes();
				var s = date.getSeconds();
				if (Y == yCurrent && M == mCurrent && D == dCurrent) {
					if (h < 10) {
						h = '0' + h
					}
					if (m < 10) {
						m = '0' + m
					}
					return h + ":" + m;
				} else if (Y == yCurrent && M == mCurrent && dCurrent - D == 1) {
					return "昨天";
				} else if (Y == yCurrent && M == mCurrent && dCurrent - D == 2) {
					return "前天";
				} else if (Y == yCurrent && M == mCurrent && dCurrent - D > 2) {
					return M + "月" + D + "日";
				} else if (Y == yCurrent && M < mCurrent) {
					return M + "月" + D + "日";
				} else if (Y < yCurrent) {
					return Y + "年" + M + "月" + D + "日";
				}

			},
		}
	}
</script>
<style scoped>
	/*显示隐藏tips*/
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s;
	}

	.fade-enter,
	.fade-leave-to

	/* .fade-leave-active below version 2.1.8 */
		{
		opacity: 0;
	}

	.chat {
		width: 100%;
		height: 100%;

		position: relative;

	}

	.loadGif {
		position: absolute;
		background: #FFFFFF;
		left: 0;
		top: 0;
		bottom: 160px;
		right: 0;
		z-index: 100;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.loadGif img {
		width: 20px;
		height: 20px;
	}

	.wrap {
		width: 100%;
		height: 100%;
		padding: 20px;
		overflow: auto;
	}


	.msg {
		position: fixed;
		bottom: 0;
		background: #f1f1f1;
		width: 100%;
		display: flex;
		padding: 6px 0;
	}

	.msg .ig {
		padding: 4px 8px;
	}

	.msg .ig img {
		height: 30px;
		width: 34px;
		display: block;
		opacity: 0.4;
	}

	.msg .put {
		flex-grow: 1;
	}

	/*.msg .put input{
	height: 38px;
	border: none;
	display: block;
	padding: 0;
	width: 100%;
	padding-left: 5px;
	border-radius: 3px;
}*/
	.msg .put textarea {
		height: 38px;
		border: none;
		display: block;
		padding: 0;
		width: 100%;
		padding-left: 5px;
		border-radius: 3px;
		box-sizing: border-box;
		padding-top: 7px;
	}

	.msg .btn {
		padding-right: 10px;
		padding-top: 2px;
	}

	.msg .btn div {
		background: #41B883;
		width: 50px;
		color: #FFFFFF;
		font-size: 14px;
		text-align: center;
		line-height: 34px;
		cursor: pointer;

	}

	.leftMsg {
		position: relative;
		margin-bottom: 25px;
	}

	.leftMsg .tp {
		position: absolute;
		width: 40px;
		height: 40px;
		overflow: hidden;
		border-radius: 4px;
	}

	.leftMsg .tp img {
		width: 40px;
		height: 40px;
	}

	.leftMsg .box {
		padding-left: 55px;
	}

	.leftMsg .box .name {
		float: left;
		font-size: 16px;
	}

	.leftMsg .box .date {
		float: right;
	}

	.leftMsg .box .content {
		margin-top: 10px;
		font-size: 16px !important;
		color: #FFFFFF;
		line-height: 22px;
		padding: 10px;
		background-color: #5FB878;
		border-radius: 4px;
		z-index: 10;
		word-wrap: break-word;
		word-break: break-all;
		display: inline-block;
		background: #FFFFFF;
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.6) !important;
		color: #333333;

	}

	.White {
		background: #FFFFFF !important;
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.6) !important;
	}

	.leftMsg .box .content .text {
		font-size: 15px;
	}

	.leftMsg .box .content .text img {
		max-width: 300px;
	}




	.rightMsg {}

	.rightMsg .tp {
		right: 0px;
	}

	.rightMsg .box {
		padding-left: 0px;
		padding-right: 55px;
		position: relative;
	}

	.rightMsg .box .name {
		float: right;
	}

	.rightMsg .box .date {
		float: left;
	}

	.rightMsg .box .content {
		float: right;

	}

	.menus {
		position: absolute;
		border-radius: 4px;
		overflow: hidden;
		text-align: center;
		background: rgba(0, 0, 0, 0.6);
		z-index: 10;
		right: 0;
		cursor: pointer;
		top: 20px;
		display: flex;
	}

	.menus .it {
		padding: 10px 10px;
		font-size: 10px;
		color: #FFFFFF;
		float: left;
		flex-grow: 1;

	}

	.menus .it:hover {
		background: rgba(0, 0, 0, 0.4);
		color: #FFFFFF;
	}

	.coupon {
		font-size: 20px;
		color: #444;
		background-color: #fff;
		border-radius: 10px;
		z-index: 10;
		word-wrap: break-word;
		word-break: break-all;
		padding: 0 10px;
		cursor: pointer;
	}

	.coupon .title {}

	.coupon .cont {
		font-size: 14px;
	}

	.coupon .cont .qiang {
		color: red;
		margin: 5px;
	}

	.coupon .cont .shou {
		margin: 5px;
	}

	.coupon .say {
		font-size: 14px;
		color: #999999;
	}

	.myNOTICE {
		text-align: center;
		font-size: 12px;
	}

	.moreInfo {
		text-align: center;
		font-size: 14px;
		cursor: pointer;
		padding-bottom: 5px;
		background: #f2f2f2;
		margin-bottom: 15px;
		border-radius: 8px;
		padding: 8px 0;
	}

	/* .myMsg{
	height: 140px;
	position: relative;
} */
	.myMsg {
		height: 200px;
		position: relative;
	}

	.myMsg .top {
		position: relative;
	}

	.myMsg .top ul {
		overflow: hidden;
		border-top: 1px solid #F1F1F1;
		background-color: rgba(255, 255, 255, .5);
		padding: 0 5px;
	}

	.myMsg .top li {
		float: left;

	}

	.myMsg .top span {
		display: block;
		height: 40px;
		line-height: 40px;
		font-size: 24px;
		color: #666666;
		cursor: pointer;
		padding: 0px 10px;
	}

	.myMsg .center {
		padding: 0 10px;
	}

	.myMsg .center textarea {
		height: 110px;
		width: 100%;
		resize: none;
		outline: none;
		background: none;
		border: none;
		font-size: 14px;
		font-weight: bold;
	}

	.myMsg .bottom {
		position: absolute;
		bottom: -15px;
		right: 20px;
		background: none;
		overflow: hidden;
		/* padding: 0px 10px; */

	}

	.myMsg .bottom .btn {
		display: inline-block;
		font-size: 14px;
		line-height: 32px;
		padding: 0 20px;
		background-color: #5FB878;
		color: #fff;
		border-radius: 3px;
		float: right;
		cursor: pointer;
	}

	.emoji {}

	.emoji ul {}

	.emoji li {
		width: 12.5%;
		float: left;
		font-size: 30px;
		text-align: center;
		line-height: 40px;
		cursor: pointer;
	}

	.mypic {}

	.mypic {}

	.mypic ul {
		overflow: hidden;
	}

	.mypic li {
		float: left;
		width: 132px;
		height: 132px;
		overflow: hidden;
		padding: 2px;
	}

	.mypic li img {
		width: 100% !important;
	}

	/*sss*/
	.replyBox {
		border-left: 2px #409EFF solid;
		padding-left: 10px;
	}

	.replyItem {
		font-size: 10px;
		overflow: hidden;
	}

	.replyName {
		font-size: 10px;
		line-height: 1;
		color: #409EFF;
	}

	.replyCotent {
		line-height: 1;
		font-size: 10px;
	}

	.replyImg {
		width: 30px !important;
		height: 30px !important;
		float: left;
		margin-right: 5px;
	}

	.rons {
		float: left;
	}

	.replyvideo {
		width: 60px;
	}

	.huiFuXX {
		margin: 0 !important;
		margin: 0 !important;
		position: absolute;
		width: 100% !important;
		height: 40px !important;
		background: #ffffff !important;
		top: -40px !important;
		z-index: 10;
		border-radius: 0 !important;
		left: 0;
		overflow: hidden;
		padding: 10px;
		box-sizing: border-box;
	}

	.inputRoom .replyItem img {
		margin-left: 0 !important;
	}

	.close {
		position: absolute;
		right: 0;
		top: 0;
		height: 40px;
		background: #ffffff;
		padding: 10px;
		padding-right: 15px;
	}

	.close img {
		width: 20px;
		height: 20px;
	}

	.contentTLJ {
		background: #F56C6C !important;
		border-radius: 4px;
		overflow: hidden;
		width: 300px;
		box-sizing: border-box;
		padding: 0 !important;

	}

	.contentTLJ .name {
		text-align: center;
		padding: 8px 0;
		float: none !important;
		color: #ffffff;
		padding: 10px 15px;
	}

	.contentTLJ .tt {
		background: #FFFFFF !important;
		padding: 10px 10px;
	}

	.yhq {
		padding-top: 50px;
		background: #F3F3F3;
	}

	.yhq .box {
		background: url(../../assets/img/yhq2.png) 0 0 no-repeat;
		width: 250px;
		height: 120px;
		margin: auto;
		background-size: 100% 100%;
	}

	.yhq .name {
		line-height: 60px;
		text-align: center;
		color: #FFFFFF;
	}

	.yhq .tkl {
		line-height: 60px;
		text-align: center;
		color: #FE4F46;
	}

	.yhq .tt {
		color: #FE4F46;
		text-align: center;
		padding-top: 20px;
	}


	.goodsmy {}

	.goodsmy img {
		width: 200px;
	}

	.goodsmy .text {
		font-size: 16px;
		font-weight: bold;
	}

	.goodsmy h1 {
		font-weight: normal;
		display: inline-block;
		font-size: 15px;
		color: red;
		line-height: 40px;
	}

	.goodsmy h1 label {}

	.goodsmy h1 del {}

	.goodsmy h1 span {}

	.goodsmy h2 {}

	.jubaoCss button {
		width: 100%;
		margin: 0;
		margin: 5px 0;
	}



	.cardWrap {
		margin: 10px 20px;
	}

	.cardBox {
		overflow: hidden;
		border: 1px #DFDFDF solid;
		border-radius: 8px;
		min-height: 80px;
		position: relative;
		padding-left: 90px;
		background: #FFFFFF;
	}

	.cardBox .imgs {
		width: 80px;
		height: 80px;
		padding: 5px;
		position: absolute;
		left: 0;
		top: 0;

	}

	.cardBox .imgs img {
		width: 100%;
		height: 100%;
	}

	.cardBox .imgs .hds {
		width: 30px;
		height: 30px;
		position: absolute;
	}

	.cardBox .textbox {
		padding: 10px 0;
		flex-grow: 1;
	}

	.cardBox .textbox .titles {
		font-weight: bold;
	}

	.cardBox .textbox .desc {
		font-size: 12px;
		color: #888888;
	}

	.wenjianBox {
		position: relative;
		margin-top: 10px;
		font-size: 16px !important;
		color: #FFFFFF;
		line-height: 22px;
		padding: 10px;
		background-color: #5FB878;
		border-radius: 4px;
		z-index: 10;
		word-wrap: break-word;
		word-break: break-all;
		display: inline-block;
		background: #FFFFFF;
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.6) !important;
		color: #333333;
		padding-left: 40px;
	}

	.wenjianBox .imgs {
		padding-right: 6px;
		position: absolute;
		left: 5px;
		top: 5px;
	}

	.wenjianBox .imgs img {
		height: 30px;
	}

	.wenjianBox .textbox {}

	.wenjianBox .textbox .titles {}

	a {
		display: block;
		color: #333333;
	}

	.fuwuBox {
		overflow: hidden;
		border: none;
		border-radius: 5px;
		min-height: 1px;
		position: relative;
		background: #E33C64;
		padding-left: 0px;
	}

	.fuwu {
		padding: 10px;
	}

	.fuwu .fuwu_top {
		overflow: hidden;
		position: relative;
		padding-left: 45px;
		border-bottom: 1px #ffffff solid;
	}

	.fuwu .fuwu_top img {
		position: absolute;
		height: 50px;
		left: -8px;
		top: -6px;
	}

	.fuwu .fuwu_top .rons {
		font-size: 14px;
	}

	.fuwu .fuwu_top .rons .order {
		color: #ffffff;
	}

	.fuwu .fuwu_top .rons .money {
		color: #ffffff;
		padding-bottom: 10px;
	}

	.fuwu .zd {
		color: #fff;
		font-size: 14px;
	}

	.backgrondfff {
		display: block;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #666666;
		cursor: pointer;
		padding: 0px 10px;
		background: #DFDFDF;
	}

	.activeBackground {
		background: #E64340 !important;
		display: block;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #FFFFFF;
		cursor: pointer;
		padding: 0px 10px;
	}

	.ai {
		cursor: pointer;
		padding: 0px 15px;
	}

	svg {
		margin-top: 6px;

	}

	.aibox {
		position: absolute;
		bottom: 41px;
		z-index: 1000;
		width: 100%;
		height: 300px;
		border-top: 1px #DFDFDF solid;
		overflow: hidden;
	}

	.aibox {
		background: #FFFFFF;
	}

	.aiRon {
		display: flex;
		flex-wrap: wrap;
		max-height: 258px;
		overflow: auto;
	}

	.aiItem {}

	.aiItemb {
		padding: 5px 0 !important;
		cursor: default !important;
	}

	.aiItem {
		padding: 20px 0;
		width: 25%;
		box-sizing: border-box;
		cursor: pointer;
		overflow: hidden;
	}

	.aiItema:hover {
		background: #f2f6fc;
	}

	.aiItem h1 {
		font-size: 12px;
		text-align: center;
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.aiItem p {
		font-size: 12px;
		text-align: center;
		color: #888888;
	}

	.aiItem img {
		height: 60px;
		display: block;
		margin: auto;
	}

	.aiItem button {
		display: block;
		margin: auto;
		width: 100px;
		margin-top: 5px;
	}

	.aititle {
		overflow: hidden;
		background: #F1F1F1;
		padding: 5px;
	}

	.aititle .name {
		float: left;
		padding-left: 15px;
		line-height: 32px;
	}

	.aititle button {
		float: right;
	}

	.nameai {
		position: absolute;
		top: 0;
		height: 42px;
		left: 0;
	}

	.aib {
		font-weight: normal;
		padding: 0px 10px;
		cursor: pointer;
		display: inline-block;
		line-height: 42px;
		height: 42px;
		text-align: center;
	}

	.aibActive {
		color: #409EFF;
		background: #E4E7ED;
	}

	/* 拖拽 */
	#drop-area {
		margin-top: 100px;
		width: 100%;
		height: 100px;
		background-color: #fff;
		border: 1px solid red;
	}

	.drop-active {
		background-color: rgba(231, 234, 246, 0.8);
	}

	/* .itemxx {
      margin: 4px;
	  z-index: 5000;
    } */
</style>


// WEBPACK FOOTER //
// src/components/im/chatIm.vue